export const pl = {
  cookieInfo:
    'W celu udoskonalania naszego serwisu używamy plików cookie. Możesz zablokować ich zapisywanie na Twoim komputerze, zmieniając ustawienia swojej przeglądarki. Więcej informacji znajdziesz',
  here: 'tutaj',
  hi: 'Witaj',
  rememberMe: 'Zapamiętaj mnie',
  publicNetwork: 'Publiczne adresy IP',
  contactWithUs: 'skontaktuj się z nami',
  added: 'Dodano',
  disks: 'dysków',
  name: 'Nazwa',
  creditCard: 'Karta kredytowa',
  Country: 'Kraj',
  virtualMachines: 'Maszyny wirtualne',
  basicDisc: 'Dysk podstawowy',
  basicDiscShort: 'Dysk podst.',
  additionalDisc: 'Dysk dodatkowy',
  additionalDiscShort: 'Dysk dod.',
  hardwareParameters: 'Profil sprzętowy',
  invoicedCompany: 'Fakturowany podmiot',
  invoiceAddress: 'Adres do faktury',
  authorization: 'Autoryzacja',
  password: 'Hasło',
  SSHKeys: 'Klucze SSH',
  choosen: 'Wybrano',
  change: 'zmień',
  privateNetwork: 'Sieć prywatna',
  choosePrivateNetwork: 'Wybierz sieć prywatną',
  or: 'lub',
  addNew: 'Dodaj nową',
  summary: 'Podsumowanie',
  operatingSystem: 'System operacyjny',
  h: 'godz.',
  hour: 'na godzinę',
  month: 'mc',
  monthly: 'miesięcznie',
  days: 'dni',
  amount: 'Ilość',
  bandwidth: 'Transfer',
  chooseOperatingSystem: 'Wybierz system operacyjny',
  chooseOSVersion: 'Wybierz wersję',
  backToPanel: 'wróć do panelu',
  back: 'wróć',
  physicalMachines: 'Maszyny fizyczne',
  networks: 'Sieci',
  network: 'Sieć',
  other: 'Inne',
  regions: 'Regiony',
  generalView: 'Pogląd ogólny',
  enabled: 'Włączona',
  turnOff: 'wyłącz',
  turnOn: 'włącz',
  backup: 'Kopia zapasowa',
  backupOff: 'wyłącz backup',
  backupOn: 'włącz backup',
  contactUsToDeactivateBackup: 'Skontaktuj się z nami, by wyłączyć backup.',
  suspend: 'uśpij',
  reboot: 'restart',
  on: 'Włączony',
  off: 'Wyłączony',
  busy: 'Zajęta',
  machine_error: 'Błąd',
  suspended: 'Uśpienie',
  freeze: 'zamróź',
  total: 'razem',
  sorting: 'Sortowanie',
  creationDate: 'Data utworzenia',
  created: 'Utworzone',
  trialActivationPopupHeader: 'Aktywowano okres próbny!',
  trialActivationPopupDescription: 'Aktualny stan konta workspace {name}: ',
  createdBy: 'Utworzone przez',
  state: 'Stan',
  diskSpace: 'Przestrzeń dyskowa',
  delete: 'usuń',
  console: 'konsola',
  description: 'Opis',
  contents: 'Treść',
  issueType: 'Temat',
  date: 'Data',
  history: 'Historia',
  cost: 'Koszt',
  costs: 'Koszty',
  permissions: 'Uprawnienia',
  billingPeriod: 'Okres rozliczeniowy',
  details: 'Szczegóły',
  computing: 'Przetwarzanie danych',
  licences: 'Licencje',
  select: 'Wybierz',
  address: 'Adres',
  type: 'Typ',
  additional: 'Dodatkowy',
  main: 'Główny',
  deleteSelected: 'Usuń zaznaczone',
  addressing: 'Adresacja',
  connectedMachines: 'Podłączone maszyny',
  machineName: 'Nazwa maszyny',
  newMachineName: 'Nowa nazwa maszyny',
  action: 'Akcja',
  allow: 'zezwól',
  enterName: 'Wpisz nazwę',
  forWwwServer: 'Dla serwera www',
  downloadClient: 'Pobierz klienta VPN',
  username: 'Nazwa użytkownika',
  enterUserName: 'wpisz nazwę użytkownika',
  enterUserEmail: 'wpisz e-mail użytkownika',
  accountSettings: 'Ustawienia konta',
  logout: 'Wyloguj',
  loginToOneStepCloud: 'Zaloguj się do One Step Cloud',
  dontYouHaveAnAccount: 'Nie masz konta?',
  doYouHaveAnAccount: 'Masz już konto?',
  nameAndSurname: 'Imię i nazwisko',
  changePassword: 'Zmień hasło',
  oldPassword: 'Stare hasło',
  newPassword: 'Nowe hasło',
  repeat: 'Powtórz',
  TwoStepAuthentication: 'Uwierzytelnianie dwuetapowe',
  imprint: 'Odcisk',
  SSHkeyName: 'Nazwa klucza SSH',
  SSHkeys: 'Klucze SSH',
  deleteAccount: 'Usuń konto',
  approved: 'potwierdzono',
  waitingForConfirmation: 'oczekuje na potwierdzenie',
  emailIsNotActive: 'Email nie jest aktywny. Oczekuje na potwierdzenie.',
  SearchByName: 'Szukaj po nazwie',
  SearchByAddress: 'Szukaj po adresie IP',
  sshKeysAddNew: 'Klucze SSH / dodaj nowy',
  key: 'Klucz',
  nofees: 'brak opłat',
  isEmpty: 'jest puste.',
  isWrongFormat: 'Niepoprawny format.',
  notFound: 'nie znaleziono',
  pageDoesNotExist: 'Strona, której szukasz nie istnieje.',
  goToTheHomepage: 'Przejdź na stronę główną.',
  increaseLimits: 'Zwiększ limity',
  isCollision: 'Koliduje z inną siecią.',
  isConflict: 'Zakresy portów NAT pokrywają się z innymi NAT',
  undoChange: 'Cofnij zmianę',
  accept: 'zaakceptuj,',
  deny: 'odrzuć',
  reject: 'odmów',
  markedForRemoval: 'OZNACZONO DO USUNIĘCIA',
  tooShort: 'ma za mało znaków. Użyj min. 4 znaków.',
  not_applicable: 'Nie dotyczy',
  limitExceeded: 'Przekroczono limit',
  monthlyValue: 'Szacunkowa wartość zakłada 730 godzin miesięcznie.',
  sliderIncreaseLimit: 'W celu zwiększenia limitów skontaktuj się z nami za pomocą formularza pomocy.',
  language: 'Wybierz język',
  polish: 'polski',
  english: 'angielski',
  ie: 'np. 111-222-333',
  code: 'Kod',
  company: 'Firma',
  privatePerson: 'Osoba prywatna',
  limitsReached: 'Przekroczone limity',
  unableToActivate: 'aktywacja/deaktywacja nie powiodła się',
  messageHasBeenSent: 'Wiadomość została wysłana.',
  netto: 'netto',
  diskCantBeNegativeError: 'Zmniejszanie pojemności dysków jest niemożliwe.',
  sending: 'Trwa wysyłanie...',
  loadingTransaction: 'Trwa transakcja...',
  timeInterval: 'Przedział czasowy',
  diskHDD: 'Dysk (HDD)',
  diskSSD: 'Dysk (SSD)',
  backupStorage: 'Kopia zapasowa',
  win10: 'System operacyjny',
  machinesQuantity: 'Ilość maszyn',
  checkEmail: 'Sprawdź wiadomość e-mail.',
  hasBeenBlocked: 'Zablokowano workspace',
  administrativelyAnd: 'administracyjnie oraz',
  lackOfFunds: 'z powodu braku środków.',
  lackOfPayment: 'z powodu braku opłaty.',
  endOfTheTrialPeriod: 'z powodu zakończenia okresu próbnego.',
  deletionBlockReason: 'z powodu procesu usunięcia konta.',
  administratively: 'administracyjnie.',
  sendUnlockRequest: 'Wyślij zapytanie o możliwość odblokownia.',
  and: 'oraz',
  resign: 'zrezygnuj',
  params_invalid: 'Proszę uzupełnij formularz.',
  activeSessions: 'Aktywne sesje',
  currentSession: 'Obecna sesja',
  lastActivity: 'Ostatnia aktywność',
  expires: 'Wygasa',
  unknownDevice: 'Nieznane urządzenie',
  accessTheConsole: 'Wyślij zapytanie, aby uzyskać dostęp do konsoli',
  console_inaccessible: 'Konsola jest niedostępna.',
  console_access_limit_exceeded: 'Przekroczono limit dostępu do konsoli.',
  console_access_granting_failed: 'Nie udało się przyznać dostępu do konsoli.',
  pleaseTryInAFewMinutes: 'Spróbuj ponownie za kilka minut.',
  nameAscending: 'Nazwa rosnąco',
  nameDescending: 'Nazwa malejąco',
  backupActivated: 'maszyna backupowana',
  dateRangePicker: {
    applyLabel: 'Wybierz',
    cancelLabel: 'Anuluj',
    weekLabel: 'W',
    customRangeLabel: 'Inny zakres',
    daysOfWeek: ['Nd', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'So'],
    monthNames: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    firstDay: 0,
  },
  ws: {
    transferUpdate: 'Zaktualizowano zużycie transferu.',
    firewallUpdated: 'Zaktualizowano konfigurację firewall.',
    backupActivated: 'Aktywowano tworzenie kopii zapasowej.',
    dm: {
      reserve: {
        requested: 'Trwa proces zamawiania maszyny dedykowanej...',
        succeeded: 'Pomyślnie zarezerwowano maszynę dedykowaną.',
        failed: 'Rezerwacja maszyny dedykowanej nie powiodło się.',
      },
      update: {
        succeeded: 'Pomyślnie zaktualizowano maszynę dedykowaną.',
      },
      resign: {
        requested: 'Trwa proces usuwania maszyny dedykowanej...',
        succeeded: 'Pomyślnie usunięto maszynę dedykowaną.',
        failed: 'Usuwanie maszyny dedykowanej nie powiodło się.',
      },
      power_on: {
        started: 'Maszyna dedykowana włącza się...',
        succeeded: 'Maszyna dedykowana włączona.',
        failed: 'Włączenie maszyny dedykowanej nie powiodło się.',
      },
      power_off: {
        started: 'Maszyna dedykowana wyłącza się...',
        succeeded: 'Maszyna dedykowana wyłączona.',
        failed: 'Wyłączenie maszyny dedykowanej nie powiodło się.',
      },
      reset: {
        started: 'Restart maszyny dedykowanej...',
        succeeded: 'Maszyna dedykowana zrestartowana.',
        failed: 'Restart maszyny dedykowanej nie powiódł się.',
      },
      destroy: {
        succeeded: 'Usunięto maszynę dedykowaną.',
      },
    },
    vm: {
      transferUpdate: 'Zaktualizowano zużycie transferu.',
      hardware: {
        started: 'Aktualizacja zasobów maszyny wirtualnej...',
        succeeded: 'Zasoby maszyny wirtualnej zaktualizowane.',
        failed: 'Aktualizacja zasobów maszyny wirtualnej nie powiodła się.',
      },
      create: {
        started: 'Tworzenie wirtualnej maszyny.',
        succeeded: 'Maszyna wirtualna stworzona. Prosimy sprawdź pocztę.',
        failed: 'Tworzenie maszyny wirtualnej nie powiodło się.',
      },
      update: {
        started: 'Aktualizacja maszyny wirtualnej...',
        succeeded: 'Maszyna wirtualna zaktualizowana.',
        failed: 'Aktualizacja maszyny wirtualnej nie powiodła się.',
      },
      powerOn: {
        started: 'Maszyna wirtualna włącza się...',
        succeeded: 'Maszyna wirtualna włączona.',
        failed: 'Włączenie maszyny wirtualnej nie powiodło się.',
      },
      powerOff: {
        started: 'Maszyna wirtualna wyłącza się...',
        succeeded: 'Maszyna wirtualna wyłączona.',
        failed: 'Wyłączenie maszyny wirtualnej nie powiodło się.',
      },
      suspend: {
        started: 'Rozpoczęto uśpienie wirtualnej... ',
        succeeded: 'Maszyna wirtualna uśpiona.',
        failed: 'Uśpienie maszyny wirtualnej nie powiodło się.',
      },
      restart: {
        started: 'Restart maszyny wirtualnej...',
        succeeded: 'Maszyna wirtualna zrestartowana.',
        failed: 'Restart maszyny wirtualnej nie powiódł się.',
      },
      destroy: {
        succeeded: 'Usunięto maszynę wirtualną.',
      },
    },
    workspace: {
      workspace_blocked: 'Zablokowano workspace.',
      workspace_unblocked: 'Odblokowano workspace.',
      update_name: {
        succeeded: 'Nazwa przestrzeni roboczej zmieniona.',
      },
      workspace_deleted: 'Workspace został usunięty.',
      users: {
        roleUpdate: 'Rola użytkownika zmieniona.',
        usernameUpdate: 'Nazwa użytkownika zmieniona.',
        destroy: 'Użytkownik usunięty.',
        invitation: {
          create: 'Zaproszenie wysłane.',
          destroy: 'Zaproszenie anulowane.',
        },
      },
    },
    usage_limit: {
      update: {
        succeeded: 'Limity zużycia zaktualizowane.',
      },
    },
    current_usage: {
      changed: 'Limity zużycia zmienione.',
    },
    public_ip_address: {
      create: {
        started: 'Dodawanie publicznego adresu IP...',
        succeeded: 'Publiczny adres IP dodany.',
        failed: 'Dodawanie publicznego adresu IP nie powiodło się.',
      },
      destroy: {
        started: 'Usuwanie publicznego adresu IP...',
        succeeded: 'Publiczny adres IP usunięty.',
        failed: 'Usuwanie publicznego adresu IP nie powiodło się.',
      },
    },
    private_network: {
      create: {
        started: 'Tworzenie sieci prywatnej...',
        succeeded: 'Sieć prywatna utworzona.',
        failed: 'Tworzenie sieci prywatnej nie powiodło się.',
      },
      destroy: {
        started: 'Usuwanie sieci prywatnej...',
        succeeded: 'Usunięto sieć prywatną.',
        failed: 'Usuwanie sieci prywatnej nie powiodło się.',
      },
      update: {
        started: 'Aktualizacja sieci prywatnej...',
        succeeded: 'Sieć prywatna zaktualizowana.',
        failed: 'Aktualizacja sieci prywatnej nie powiodła się.',
      },
      changed: 'Zmieniono sieć prywatną.',
    },
    nat: {
      create: {
        started: 'Tworzenie NAT...',
        succeeded: 'NAT utworzone.',
        failed: 'Tworzenie NAT nie powiodło się.',
      },
      destroy: {
        started: 'Usuwanie NAT...',
        succeeded: 'NAT usunięte.',
        failed: 'Usuwanie NAT nie powiodło się.',
      },
      changed: 'NAT zmienione.',
    },
    nic: {
      create: {
        started: 'Tworzenie interfejsu sieciowego...',
        succeeded: 'Interfejs sieciowy utworzony.',
        failed: 'Tworzenie interfejsu sieciowego nie powiodło się.',
      },
      update: {
        started: 'Aktualizacja interfejsu sieciowego...',
        succeeded: 'Interfejs sieciowy został zaktualizowany.',
        failed: 'Aktualizacja interfejsu sieciowego nie powiodło się.',
      },
      destroy: {
        started: 'Usuwanie interfejsu sieciowego...',
        succeeded: 'Interfejs sieciowy usunięty.',
        failed: 'Usuwanie interfejsu sieciowego nie powiodło się.',
      },
      changed: 'Zmieniono interfejs sieciowy.',
    },
    auditLog: {
      started: 'Tworzenie wpisu dziennika kontroli...',
      succeeded: 'Wpis dziennika kontroli utworzony.',
      failed: 'Tworzenie wpisu dziennika kontroli nie powiodło się.',
    },
    region: {
      activate: {
        started: 'Region aktywuje się.',
        succeeded: 'Region aktywowany.',
        failed: 'Aktywacja regionu nie powiodła się.',
      },
      destroy: {
        succeeded: 'Deaktywacja regionu powiodła się.',
        failed: 'Deaktywacja regionu nie powiodła się.',
      },
    },
    snapshot: {
      create: {
        started: 'Tworzenie migawki.',
        succeeded: 'Migawka utworzona.',
        failed: 'Tworzenie migawki nie powiodło się.',
      },
      restore: {
        started: 'Przywracanie migawki.',
        succeeded: 'Migawka przywrócona.',
        failed: 'Przywracanie migawki nie powiodło się.',
      },
      destroy: {
        started: 'Usuwanie migawki.',
        succeeded: 'Migawka usunięta.',
        failed: 'Usuwanie migawki nie powiodło się.',
      },
    },
    default: 'Nieobsługiwany błąd {name}',
  },
  serverErrorOccured: 'Przerwa techniczna.',
  maintenance: 'Trwają prace nad ulepszeniem portalu. Zajrzyj tu potem.',
  accountIsInactive: 'Konto jest nieaktywne.',
  accounts: {
    removePopup: {
      header: 'Twoje konto zostanie usunięte.',
      description:
        'Usunięcie konta jest nieodwracalne. Po usunięciu zostaniesz przekierowany na strone główną. Po trwałym usunięciu Twojego konta, inny użytkownik pojawi się w miejscu Twojego imienia i nazwiska. Pozostałe informacje dotyczące usuwania konta możesz znaleźć w dokumentacji dotyczącej usuwania konta.',
    },
  },
  individualPerson: 'Osoba prywatna',
  taxNumber: 'Numer podatkowy',
  advert: {
    howItWorks: 'Jak to działa?',
    howItWorksDescription:
      '\n' +
      'One Step Cloud to gotowa i łatwa w użyciu platforma do dostarczania i zarządzania dedykowanymi maszynami, maszynami wirtualnymi, usługami administracyjnymi i wsparcia dla użytkowników.',
    faq: 'Najczęściej zadawane pytania',
    userDocumentation: 'Dokumentacja użytkownika',
    allRightsReserved: 'Wszelkie prawa zastrzeżone © 2021',
  },
  validation: {
    fieldIsRequired: 'Pole jest wymagane.',
    agreementIsRequired: 'Zgoda jest wymagana.',
    used: 'został już wykorzystany.',
    isInvalid: 'jest nieważny.',
    isTooShortMin2: 'Pole jest za krótkie. Wymagane są minimalnie 2 znaki.',
    isTooShortMin4: 'Pole jest za krótkie. Wymagane są minimalnie 4 znaki.',
    isTooShortMin3: 'Pole jest za krótkie. Wymagane są minimalnie 3 znaki.',
    isTooShortMin8: 'Hasło jest za krótkie. Wymagane jest minimalnie 8 znaków.',
    isTooShortMin10: 'Pole jest za krótkie. Wymagane są minimalnie 10 znaków.',
    isTooLongMax10: 'Pole jest za długie. Użyj maksymalnie 10 znaków.',
    isTooLongMax16: 'Pole jest za długie. Użyj maksymalnie 16 znaków.',
    isTooLongMax50: 'Pole jest za długie. Użyj maksymalnie 50 znaków.',
    isTooLongMax64: 'Pole jest za długie. Użyj maksymalnie 64 znaki.',
    isTooLongMax255: 'Pole jest za długie. Użyj maksymalnie 255 znaków.',
    isTooLongMax1000: 'Pole jest za długie. Użyj maksymalnie 1000 znaków.',
    isTooLongMax1024: 'Pole jest za długie. Użyj maksymalnie 1024 znaki.',
    alreadyInUse: 'jest już używany.',
    emailAlreadyInUse: 'Podany adres email jest już używany.',
    wrongPassword: 'Niepoprawne hasło.',
    passwordDoesNotMatch: 'Niepoprawnie powtórzone hasło.',
    improvePasswordStrength: 'Zwiększ siłę hasła.',
    wrongEmailFormat: 'Niepoprawny format adresu email.',
    emailOrPassIsWrong: 'Email lub hasło jest niepoprawne.',
    oldPassIsInvalid: 'Stare hasło jest niepoprawne.',
    passDoesNotMatch: 'Powtórzenie hasła nie jest poprawne.',
    tooBigFile: 'Plik jest za duży. Dopuszczalne są pliki o wielkości do 6MB.',
    invalidFileType: 'Typ pliku jest nieprawidłowy. Poprawne formaty to png lub jpg.',
  },
  limitsText: 'Jeśli chcesz zwiększyć limity Twoich zasobów w workspace, wyślij do nas prośbę.',
  buttons: {
    activateBackup: 'Aktywuj backup',
    SKIP: 'POMIŃ',
    ADDDISC: 'DODAJ DYSK',
    goToPanel: 'PRZEJDŹ DO PANELU',
    CANCEL: 'ANULUJ',
    SAVE: 'ZAPISZ',
    ADD: 'DODAJ',
    NEXT: 'DALEJ',
    CHOOSE: 'WYBIERZ',
    creditCard: 'KARTA KREDYTOWA',
    DELETE: 'USUŃ',
    REMOVE: 'USUŃ',
    OPEN: 'OTWÓRZ',
    CLOSE: 'ZAMKNIJ',
    CREATE: 'STWÓRZ',
    CHANGE: 'ZMIEŃ',
    ACTIVATE: 'AKTYWUJ',
    TRIAL: 'OKRES PRÓBNY',
    CONFIRM: 'POTWIERDŹ',
    RESEND: 'WYŚLIJ PONOWNIE',
    SEND: 'WYŚLIJ',
    DETAILS: 'SZCZEGÓŁY',
    RESTORE: 'PRZYWRÓĆ',
    MAKE: 'ZRÓB',
    addNat: 'DODAJ NAT',
    addNetworkCard: 'DODAJ KARTĘ SIECIOWĄ',
    addNatMapping: 'DODAJ MAPOWANIE NAT',
    DISPLAY: 'WYŚWIETL',
    RESIGN: 'ZREZYGNUJ',
    contactWithUs: 'SKONTAKTUJ SIĘ Z NAMI',
    downloadClient: 'POBIERZ KLIENTA',
    createPrivateNetwork: 'UTWÓRZ SIEĆ PRYWATNĄ',
    goToThePortal: 'PRZEJDŹ DO PANELU',
    LOGIN: 'ZALOGUJ SIĘ',
    forgotPassword: 'NIE PAMIĘTAM HASŁA',
    register: 'ZAREJESTRUJ SIĘ',
    TURNON: 'WŁĄCZ',
    sendInvitation: 'WYŚLIJ ZAPROSZENIE',
    saveNewPassword: 'ZAPISZ NOWE HASŁO',
    addNewSSHKey: 'DODAJ NOWY KLUCZ SSH',
    saveAllChanges: 'ZAPISZ WSZYSTKIE ZMIANY',
    addUser: 'DODAJ UŻYTKOWNIKA',
    accept: 'ZAAKCEPTUJ',
    settings: 'USTAWIENIA',
    request: 'WYŚLIJ ZAPYTANIE',
    commingSoon: 'DOSTĘPNE WKRÓTCE',
    display: 'GENERUJ',
    copyVpnUrl: 'PUBLICZNA STRONA',
    used: 'WYKORZYSTANO',
    RENT: 'WYNAJMIJ',
  },
  tooltip: {
    insufficientPermissions: 'Brak wystarczających uprawnień, aby uzyskać dostęp do konsoli.',
    lackOfFunds: 'Brak środków. Saldo konta workspace wynosi 0 i spłata jest niemożliwa.',
    checkTaxRegulations: 'Sprawdź regulacje podatkowe w Twoim kraju.',
    outputAddress: 'Publiczny adres IP dla ruchu wychodzącego z interfejsu.',
    outputAddressNetwork: 'Domyślny publiczny adres IP dla ruchu wychodzącego z sieci.',
    addressingCIDR: 'Adres w notacji CIDR musi być z jednej z prywatnych sieci IANA (RFC1918)',
    addressingReservedByOSC: 'Podsieci zarezerwowane przez One Step Cloud',
    source:
      'Dopasowuje pakiety, których źródło jest równe podanemu adresowi IP, karcie sieciowej lub zawiera się we wprowadzonej podsieci lub sieci prywatnej.',
    sourcePort: 'Port lub zakres portów źródłowych. Tylko wtedy, gdy protokołem jest TCP lub UDP.',
    destination:
      'Dopasowuje pakiety, których cel jest równy podanemu adresowi IP, karcie sieciowej lub zawiera się we wprowadzonej podsieci lub sieci prywatnej.',
    destinationPort: 'Port lub zakres portów docelowych. Tylko wtedy, gdy protokołem jest TCP lub UDP.',
    protocol: 'Dopasowuje protokół pakietu IP.',
    promocodeActualSum: 'Podana kwota jest aktualną sumą środków z promokodu i środków przedpłaconych.',
    nip: 'Numer identyfikacji podatkowej nadawany firmom zarejestrowanym w Polsce.',
    ueVat:
      'Numer podatkowy nadawany przez lokalne urzędy krajów członkowskich Unii Europejskiej. Jeśli nie posiadasz numeru VAT-UE podaj lokalny numer podatkowy.',
    taxNumber: 'Lokalny numer podatkowy obowiązujący w kraju rejestracji firmy.',
    currentCost: 'Podana kwota to naliczony koszt od początku miesiąca do teraz.',
    expectedCost: 'Przewidywany koszt za aktualny miesiąc.',
    copyVpnUrl: 'Skopiuj adres url do publicznej strony z danymi dostępowymi klienta VPN.',
    machineType: {
      dedicated: 'Sieć dla maszyn dedykowanych.',
      virtual: 'Sieć dla maszyn wirtualnych.',
    },
  },
  agreement: {
    customSolution: 'OFERTA INDYWIDUALNA',
    subtitle: 'Rozliczenie dokonuje się na podstawie indywidualnych ustaleń.',
    infoAfterRequest: 'Dziękujemy! Wkrótce skontaktujemy się z Tobą w sprawie ustalenia szczegółów współpracy.',
  },
  scripts: {
    fullNameRequired: 'Imię i nazwisko są wymagane.',
    fullNameTooShort: 'Imię i nazwisko są za krótkie. Wymagane jest minimum 4 litery.',
    fullNameTooLong: 'Imię i nazwisko są za długie. Wymagane maksymalnie 60 znaków.',
    emailRequired: 'Adres email jest wymagany.',
    emailFormatIsWrong: 'Niepoprawny format adresu email.',
    emailIsAlreadyInUse: 'Adres email jest już używany.',
    errorOccuredDuringActivation: 'Wystąpił błąd podczas akceptowania zaproszenia.',
    errorLoggedInToDifferentAccount: 'Błąd: Jesteś zalogowany na inne konto niż to z zaproszenia.',
    oldPassIsRequired: 'Stare hasło jest wymagane.',
    newPassIsRequired: 'Nowe hasło jest wymagane.',
    newPassIsWrong: 'Nowe hasło jest zbyt proste. Zwiększ siłę hasła.',
    oldPassIsInvalid: 'Stare hasło jest niepoprawne.',
    usernameIsRequired: 'Nazwa użytkownika jest wymagana.',
    usernameIsTooShort: 'Nazwa użytkownika jest zbyt krótka. Wymagane jest minimum 4 litery.',
    usernameFormatIsWrong: 'Nazwa użytkownika może zawierać tylko litery bez polskich znaków, cyfry i znaki -_',
    usernameIsTaken: 'Nazwa użytkownika została już wykorzystana.',
    insufficientPermissions: 'Niewystarczające uprawnienia.',
    descriptionIsTooShort: 'Opis jest za krótki. Użyj minimalnie 10 znaków.',
  },
  pass: {
    successfullPassChange: 'Udało się pomyślnie zaktualizować hasło.',
    logInToContinue: 'Zaloguj się, aby kontynuować proces zmiany adresu email.',
    loginAgain: 'Zaloguj się ponownie',
    twoStepAuthenticationInfo:
      'Zmiana odbywa się dwuetapowo. Na Twój stary adres przyjdzie wiadomość z prośbą o potwierdzenie zmiany adresu e-mail. Następnie na nowy adres e-mail przyjdzie wiadomość z linkiem potwierdzającym przypisanie nowego adresu e-mail do Twojego konta.',
    confirmationLinksInfo:
      'zgłoszono prośbę zmiany adresu e-mail. Na stary i nowy adres zostały wysłane linki potwierdzające.',
    forgotPass: 'Nie pamiętam hasła',
    forgotPassInfo:
      'Podaj e-mail, na który zazwyczaj logujesz się do swojego konta. Na ten adres  wyślemy wiadomość z linkiem resetującym hasło.',
    resetPass: 'WYŚLIJ E-MAIL RESETUJĄCY HASŁO',
    resendInfo: 'Wiadomość z linkiem resetującym hasło nie dotarła? Kliknij poniżej, aby wysłać ją ponownie.',
    messageSent:
      'Jeżeli podany adres e-mail jest powiązany z kontem klienta, zostanie wysłany link umożliwiający zmianę hasła.',
    setNewPass: 'USTAW NOWE HASŁO',
    newPass: 'Nowe hasło',
    repeatNewPass: 'Powtórz nowe hasło',
    confirmAndGoToPanel: 'ZATWIERDŹ I PRZEJDŹ DO PANELU',
    byClicking: 'Klikając ZAREJESTRUJ SIĘ, wyrażasz zgodę na nasze',
    termsOfService: 'Regulamin świadczenia usługi',
    termsOfServiceLink: 'https://onestepcloud.pl/legal.html',
    privacyStatement: 'Polityka Prywatności',
    privacyStatementLink: 'https://onestepcloud.pl/policy.html',
    occasionallySend: 'Od czasu do czasu wyślemy Ci e-maile związane z kontem.',
    and: 'i',
    createVMs: 'Utwórz maszyny wirtualne w kilku krokach',
    manageVMs: 'Zarządzaj swoim środowiskiem',
    scalableVMs: 'Skalowalna infrastruktura',
    payLessForVMs: 'Płać mniej za maszyny wirtualne',
    invalidProvidedToken: 'Dostarczony token jest nieważny. Zmiana hasła nie powiodła się.',
    deleteAccountWarn: 'W celu usunięcia konta usuń najpierw workspace.',
    deleteAccountInfo:
      'W momencie usunięcia konta tracisz dostęp do usług konta, a Twoje dane osobowe są trwale usunięte.',
  },
  leftMenu: {
    virtualMachines: 'MASZYNY WIRTUALNE',
    dedicatedMachines: 'MASZYNY DEDYKOWANE',
    network: 'SIEĆ',
    vpn: 'VPN',
    help: 'FORMULARZ POMOCY',
    localizationSettings: 'USTAWIENIA REGIONU',
    publicIPaddress: 'Publiczne adresy IP (NAT)',
    privateNetwork: 'Sieci prywatne',
    routing: 'Routing',
    firewall: 'Firewall',
    settings: 'USTAWIENIA',
    billing: 'Rozliczenia',
    users: 'UŻYTKOWNICY',
    logs: 'LOGI',
  },
  virtualMachine: {
    noMachines: 'Nie ma maszyn spełniających Twoje kryteria wyszukiwania.',
    firstVMInfoPart1: 'Moja wirtualna maszyna jest gotowa - co dalej?',
    firstVMInfoPart2:
      'Na Twój adres e-mail przesłaliśmy dane do połączenia się z Twoją wirtualną maszyną (sprawdź SPAM).',
    firstVMInfoPart3:
      'Możesz z niej korzystać upubliczniając ją pod publicznym adresem IP, lub połączyć się z nią przy pomocy VPN.',
    firstVMInfoPart4: 'Aby połączyć się z Twoją maszyną postępuj zgodnie z krokami zawartymi w instrukcji na:',
    workspaceIsBlocked: 'Workspace został zablokowany.',
    cantAddNew: 'Nie ma możliwości dodania nowej maszyny.',
    contactToUnblock: 'Skontaktuj się z nami w celu odblokowania',
    consolePopup: {
      header: 'Dostęp do konsoli',
      subheader: 'Aktualnie nie masz możliwości skorzystania z dostępu do konsoli.',
    },
    newSection: {
      mandatoryFields: 'Pola obowiązkowe.',
    },
    storage: 'Dysk',
    winLicenceCheckbox:
      'Wyrażam zgodę na dostęp administracyjny Intratel sp. z o.o. do tworzonego systemu operacyjnego. Dostęp ma służyć wyłącznie do celów raportowych SPLA na rzecz Microsoft sp. z o.o.',
    wrongVMState: 'Trwa zapisywanie zmian konfiguracji maszyny wirtualnej.',
    suspendedState: 'Nie ma możliwości zmiany ustawień sprzętowych kiedy maszyna jest uśpiona.',
    restartInfo: 'Maszyna zostanie uruchomiona ponownie z powodu zmiany ilości vCPU lub RAM.',
    snapshotExists: 'Przed zmianą ustawień sprzętowych usuń snapshot.',
    snapWrongVMState: 'Trwa zapisywanie zmian konfiguracji maszyny wirtualnej.',
    noVirtualMachines: 'Brak maszyn wirtualnych',
    insufficentPermissions: 'Brak wystarczających uprawnień do stworzenia nowej maszyny dla roli „tylko do odczytu”.',
    createFirstVM: 'Stwórz pierwszą maszynę wirtualną',
    createNewMachine: 'STWÓRZ NOWĄ MASZYNĘ',
    create: 'Tworzysz',
    createDescription:
      'W OSC możesz stworzyć wirtualny serwer (VPS) na bazie systemów operacyjnych typu Ubuntu, Microsoft Windows Server, Centos, Debian, itp.',
    edit: 'Edytujesz i zarządzasz',
    editDescription:
      'Możesz zwiększać lub zmniejszać zasoby obliczeniowe, dodawać lub usuwać dyski zmieniając tym samym ilość przestrzeni dyskowej potrzebnej do funkcjonowania twojej maszyny.',
    pay: 'Płacisz od zużycia',
    payDescription:
      'Rozliczasz się z nami sekundowo za wykorzystanie sprzętu, a udostępnione API umożliwia oprogramowaniu włączanie i wyłączanie maszyn kiedy tylko tego potrzebujesz.',
    dedicatedMachines: 'Maszyny dedykowane',
    newVirtualMachine: 'Nowa wirtualna maszyna',
    ToIncreaseTheQuantity: 'W celu zwiększenia ilości',
    egVirtualMachine: 'np. maszyna_wirtualna',
    virtualMachine: 'Maszyna wirtualna',
    privateIPAddresses: 'Prywatne adresy IP',
    overcharged: 'Naliczono',
    remained: 'do końca',
    expenditure: 'Aktualne zużycie',
    machineCostsWarning: 'Uwaga! Zmiany, które wprowadzisz wpłyną na koszty maszyny.',
    totalValueofChanges: 'Łączna wartość zmian',
    costAfterChanges: 'Koszt maszyny po zmianach',
    snapshotText:
      'Snapshot to opcja archiwizacji bieżących ustawień i stanu maszyny wirtualnej ze wszystkimi danymi na niej. Wymaga dodatkowej przestrzeni (dane + obecnie używa pamięci RAM).',
    snapshotShouldBeRemoved: 'Snapshot nie powinien trwać dłużej niż 3 dni.',
    restoreSnapshotText:
      'Twoja maszyna wirtualna powróci do pierwotnego stanu z punktu przywracania. Pamiętaj, aby usunąć snapshot do 3 dni po jego zrobieniu. Długotrwałe przechowywanie migawki może negatywnie wpłynąć na działanie tej maszyny wirtualnej.',
    deleteSnapshotText:
      'Usunięcie snapshota spowoduje utratę możliwości przywracania maszyny wirtualnej z określonego okresu.',
    createSnapshotText:
      'Pamiętaj, aby usunąć snapshota do 3 dni po jego zrobieniu. Dłuższe przetrzymywanie snapshota może negatywnie wpłynąć na działanie tej maszyny wirtualnej.',
  },
  dedicatedMachine: {
    rentDedicatedMachine: 'WYNAJMIJ MASZYNĘ DEDYKOWANĄ',
    dedicatedMachines: 'Maszyny dedykowane',
    dedicatedMachine: 'Maszyna dedykowana',
    specification: 'Model',
    dateOfRent: 'Data wynajęcia',
    theMinimumRentalPeriod: 'Minimalny czas najmu',
    theMinimumRentalCost: 'Minimalny koszt najmu',
    additionally: 'Dodatkowo',
    noPermissionsToRentDM:
      'Nie masz uprawnień, by wynająć maszynę dedykowaną. Zaktualizuj metodę płatności, by móc wynająć maszynę.',
    lackOfFunds: 'Brak uprawnień do akcji na OKRESIE PRÓBNYM.',
    noDedicatedMachinesAvailable: 'Produkt jest aktualnie niedostępny.',
    insufficentPermissions:
      'Brak wystarczających uprawnień do wynajęcia maszyny dedykowanej dla roli „tylko do odczytu”.',
    minUsageFundsMissing: 'Brak wystarczających środków na pokrycie kosztu minimalnego.',
    noFundsToRentDM: 'Przejdź do ustawień lub skontaktuj się z nami w celu doładowania konta workspace.',
  },
  keysConf: {
    availableSSHkeys: 'Lista dostepnych kluczy SSH',
    chooseKyes: 'Wybierz klucze z listy',
    orAddNewKey: 'lub dodaj nowy klucz SSH',
    choosenKeys: 'Wybrane klucze',
    emptyList: 'Lista jest pusta',
    noSelected: 'Brak wybranych kluczy SSH',
    dontHaveKey: 'Nie masz klucza SSH?',
    learnHowTo: 'Dowiedz się jak',
    generateSSHKey: 'wygenerować klucz SSH',
    docsLink: 'https://docs.onestepcloud.pl/u%C5%BCytkownicy/managing-ssh-keys',
    newKey: 'Nowy klucz',
    emptyKeysListInfo: 'Wybrana lista kluczy jest pusta. Dodaj klucz SSH.',
  },
  dedicatedPublicIpAddress: {
    label: 'Udostępnij maszynę publicznie',
    limitErrorInfo: 'Nie można dodać dedykowanego publicznego adresu IP, ponieważ limit został osiągnięty.',
    description:
      'Powiąż maszynę z nowym adresem publicznym. Pomiędzy nimi zostanie stworzone mapowanie NAT one-to-one.',
    paragraph:
      'Jeden publiczny adres IP jest dostarczany z maszyną wirtualną w cenie. Dedykowany jest dodatkowo płatny i nie jest wymagany.',
  },
  net: {
    addNewPrivateNetwork: 'Dodaj nową sieć prywatną',
    addingNewPNIsInProgress:
      'Rozpoczęto proces dodawania nowej sieci prywatnej. Proszę poczekaj na utworzenie intrastruktury.',
    requiredDedicatedNetwork:
      'Dedykowana sieć prywatna jest wymagana, aby wynająć maszynę. Możesz ją stworzyć w zakładce sieci prywatne.',
    canNotDeleteAddress: 'Nie można usunąć adresu!',
    addressIsUsedForPN: 'Adres jest używany jako wyjściowy dla sieci ',
    addressIsUsedForNIC: 'Adres jest używany jako wyjściowy dla interfejsu sieciowego',
    inTheMachine: 'w maszynie',
    createdNATMappings: 'Istnieją utworzone mapowania NAT.',
    natsWillBeDeleted: 'Zostaną usunięte wraz z adresem.',
    cantDeletePrimary: 'Nie można usunąć głównego publicznego adresu IP.',
    cantDeletePrivateNetwork: 'Nie można usunąć sieci prywatnej, jeżeli podłączona jest maszyna.',
    restartRequired:
      'Aby maszyna pobrała nowy adres IP konieczny jest jej restart lub wywołanie żądania DHCP z wewnątrz systemu operacyjnego.',
    insufficentPermissions: 'Brak wystarczających uprawnień do konfiguracji sieci dla roli „tylko do odczytu”.',
    firewallInsufficentPermissions:
      'Brak wystarczających uprawnień do konfiguracji reguł firewall dla roli „tylko do odczytu”.',
    wrongVMState: 'Trwa zapisywanie zmian konfiguracji maszyny wirtualnej.',
    firewallRulesSaved: 'Zmiany konfiguracji firewall zostały pomyślne zapisane.',
    defaultForPrivateNet: 'Domyślny dla sieci prywatnej',
    UnableToConnect: 'Nie można połączyć się z Twoją maszyną!',
    addOneNetwork: 'Aby to zrobić należy dodać co najmniej jedną kartę sieciową.',
    UnableToConnectWithoutNAT: 'Obecnie nie ma dodanych mapowań NAT.',
    addOneNat: 'Dodaj pierwsze mapowanie NAT.',
    networkCard: 'Karta sieciowa',
    networkCardName: 'Nazwa karty sieciowej',
    privateAddress: 'Adres IP',
    cantAddMoreNics:
      'Nie można dodać więcej kart sieciowych ponieważ zostały już wykorzystane wszystkie sieci prywatne.',
    anyInfo: 'Nie tylko TCP/UDP, ANY odpowiada za przemapowanie wszystkich pakietów IP niezależnie od protokołu.',
    outputAddress: 'Adres wyjściowy',
    defaultForPrivateNetwork: 'Domyślny dla sieci prywatnej',
    default: 'Domyślny',
    NATmappings: 'Mapowania NAT',
    emptyNATmappings: 'Obecnie nie ma dodanych mapowań NAT. Dodaj pierwsze mapowanie NAT.',
    addNat: 'Dodaj NAT',
    createFirewallRule: 'Utwórz regułę firewall',
    IPaddress: 'Adres IP',
    publicIPaddress: 'Publiczny adres IP',
    privateIPaddress: 'Prywatny adres IP',
    protocol: 'Protokół',
    publicPort: 'Port publiczny',
    localPort: 'Port lokalny',
    sourcePort: 'Port źródłowy',
    destinationPort: 'Port docelowy',
    source: 'Źródło',
    destination: 'Cel',
    associatedNAT: 'Powiązany NAT',
    associatedPN: 'Powiązana sieć prywatna',
    PublicIPaddresses: 'Publiczne adresy IP',
    addPublicIpAddress: 'DODAJ PUBLICZNY ADRES IP',
    numberOfMappings: 'Ilość mapowań NAT',
    createPrivateNetwork: 'Utwórz sieć prywatną',
    removePrivateNetwork: 'USUŃ SIEĆ PRYWATNĄ',
    defaultPublicAddress: 'Wyjściowy adres publiczny',
    publicIPAddressDialogInfo:
      'Dodanie nowego publicznego adresu IP wpłynie na zwiększenie kosztów pracy infrastruktury',
    createNewRule: 'UTWÓRZ NOWĄ REGUŁĘ',
    firewallRulesInfo:
      'Reguły są przetwarzane według rosnącej kolejności. Zastosowana będzie pierwsza pasująca reguła.',
    vpnDialogInfoPart1: 'Wpisz hasło VPN. Znajdziesz je w wiadomości e-mail, którą wysłaliśmy na adres',
    vpnDialogInfoPart2: 'zaraz po tym, gdy użytkownik został dodany do usługi VPN w regionie',
    isWrongRange: 'niedopuszczalny zakres portów',
    noConnectedMachines: 'Brak podłączonych maszyn',
    privateNetworksLimit: 'Limit sieci prywatnych wynosi 7. Nie możesz dodać więcej sieci prywatnych.',
    publicIpAddressesLimit:
      'Limit publicznych adresów IP został osiągnięty. Nie możesz dodać więcej publicznych adresów IP.',
    UnableToCreateNatWithoutVM: 'Nie ma możliwości utworzenia mapowań w przypadku braku maszyny wirtualnej.',
    createVM: 'Stwórz maszynę wirtualną',
    machineType: 'Typ',
    noDedicatedNetworks: 'Brak sieci dedykowanych',
    type: {
      virtual: 'Wirtualna',
      dedicated: 'Dedykowana',
    },
  },
  vlan_limit_reached: 'Osiągnięto maksymalną liczbę utworzonych sieci VLAN.',
  private_networks_limit_reached: 'Osiągnięto maksymalną liczbę utworzonych sieci prywatnych.',
  private_network_with_nics: 'Nie można usunąć sieci z podłączonymi interfejsami.',
  settings: {
    name: 'Nazwa',
    mySettings: 'Moje ustawienia',
    nick: 'Nick: (Opcjonalnie)',
    emailNotifications: 'Powiadomienia e-mail',
    unsubscribeFromWorkspace: 'Wypisz się z workspace',
    workspaceSettings: 'Ustawienia workspace',
    ForceTwoFactorAuthentication: 'Wymuś uwierzytelnianie dwuetapowe',
    deleteWorkspace: 'Usuń workspace',
    sendRemoveConfirmationEmail: 'Wyślij potwierdzenie',
    deleteWorkspaceInfo:
      'Czy na pewno chcesz usunąć workspace? Możesz go również przepisać na innego użytkownika. Informacje jak to zrobić znajdziesz w dokumentacji',
    signOff: 'WYPISZ SIĘ',
    deleteWorkspaceConfirm: 'Czy na pewno chcesz usunąć workspace',
    deleteWorkspaceDescription:
      'Usunięcie workspace wiąże się z usunięciem całej infrastruktury, raportów i wszelkich informacji zawartych w nim.\n' +
      'Podczas usuwania zamykany jest okres rozliczeniowy i pobierane są środki z Twojego konta.\n' +
      'Jeśli opłacenie okresu rozliczeniowego nie będzie możliwe - cały proces zostanie przerwany.',
    deleteWorkspaceEmail: 'Na Twój adres e-mail prześlemy link potwierdzający usuwanie workspace.',
    deleteWorkspaceEmailHasBeenSend: 'Wysłano maila z potwierdzeniem. Proszę sprawdź pocztę.',
    workspaceRemovalIsInProgress: 'Workspace aktualnie jest usuwany.',
    afterLeaving: 'Po opuszczeniu',
    willBeAnonymized: 'wszystkie Twoje dane i logi operacji wykonanych przez Ciebie zostają zanonimizowane.',
    trialExpiredDeleteInfo:
      'Okres próbny zakończył się i workspace został zablokowany. Doładuj środki lub skontaktuj się z nami, aby odblokować workspace, a następnie usunąć.',
    billingOverdueDeleteInfo:
      'Aktualnie workspace jest zablokowany z powodu zaległych płatności. Ureguluj zaległości i odblokuj workspace, aby następnie go usunąć.',
    startTheRemovalProcess: 'Rozpocznij proces usuwania',
    tokenIsInvalid: 'Token jest nieprawidłowy lub wygasł. Okres jego ważności to 1 godzina.',
    blockedWorkspaceDeleteInfo:
      'Nie udało się automatycznie pobrać należności za ostatni okres rozliczeniowy. Opłać go, aby usunać konto.',
    deletionProccessIsInProgress: 'Trwa usuwanie...',
    successfullyRemovedWorkspace: 'Workspace został pomyślnie usunięty.',
    removalHasFailed:
      'Nie udało się opłacić zaległych okresów rozliczeniowych, dlatego usuwanie workspace nie powiodło się. Ureguluj zaległości, aby ponowić usuwanie.',
    requestToRemoveIfContract:
      'Została zawarta umowa (oferta indywidualna). Skontaktuj się z nami w celu rozwiązania umowy.',
    removeWorkspaceRequest: 'Proszę o rozwiązanie umowy.',
    removeWorkspaceMessageSent: 'Wysłano prośbę o usunięcie workspace (rozwiązanie umowy)',
    infoAfterRemoveRequest: 'Dziękujemy! Wkrótce skontaktujemy się z Tobą w celu rozwiązania umowy.',
  },
  billing: {
    contract_signed: 'Podpisano umowę',
    leftTopay: 'podlega opłacie',
    freeBandwidthOut: 'Bezpłatny transfer wychodzący',
    freeBandwidth: 'W tym regionie transfer wychodzący jest bezpłatny.',
    usedBandwidth: 'Zużyty transfer wychodzący',
    bandwidthPart1: 'W tym regionie transfer wychodzący do',
    bandwidthPart2: 'jest darmowy. Za każde rozpoczęte 10GB naliczymy opłatę w wysokości',
    bandwidthPart3: '',
    trialContact: 'Proszę o kontakt w sprawie aktywacji okresu próbnego.',
    trialSent: 'Wysłano prośbę o kontakt w sprawie aktywacji okresu próbnego.',
    contractContact: 'Proszę o kontakt w sprawie umowy.',
    contractSent: 'Wysłano prośbę o kontakt w sprawie umowy.',
    netPrices: 'Podane ceny są cenami netto.',
    anotherTerm: 'Inny termin',
    promocodeInfo: 'Promokod zwiększy saldo danego workspace. Dany promokod może być wykorzystany tylko raz.',
    euVat: 'UE VAT',
    companyName: 'Nazwa firmy',
    currency: 'Waluta',
    address: 'Adres',
    zipCode: 'Kod pocztowy',
    city: 'Miasto',
    state: 'Województwo',
    regions: 'Regiony',
    billing: 'Rozliczenia',
    taxRate: 'Twoja stawka VAT',
    pricingType: 'Podstawa rozliczeń',
    agreement: 'Umowa (oferta indywidualna)',
    taxNumber: 'Numer identyfikacji podatkowej',
    generateReport: 'Generuj raport',
    currentCost: 'Bieżący koszt',
    expectedCost: 'Przewidywany koszt',
    billingPeriods: 'Okresy rozliczeniowe',
    invoices: 'Faktury',
    invoice: 'Faktura',
    expiration: 'Ważność',
    changeCreditCard: 'ZMIEŃ KARTĘ KREDYTOWĄ',
    creditCard: 'Karta kredytowa',
    addCreditCard: 'DODAJ KARTĘ KREDYTOWĄ',
    changeData: 'ZMIEŃ DANE',
    account: 'Saldo konta',
    enterCode: 'WPROWADŹ PROMOKOD',
    details: 'szczegóły',
    accountStatusDetails: 'Szczegóły stanu konta',
    generalBalance: 'Saldo ogólne',
    topUpAccount: 'DOŁADUJ KONTO',
    rechargeAccountWithACode: 'Doładuj konto za pomocą promokodu',
    enterTheCode: 'Wprwadź promokod',
    useYourFunds: 'WYKORZYSTAJ',
    amount: 'Kwota',
    paymentStatus: 'Status płatności',
    downloadFiles: 'Pobierz plik pdf',
    report: 'Raport',
    reports: 'Raporty',
    payable: 'Do spłaty',
    noCost: 'Brak kosztów',
    paid: 'Zapłacono',
    unpaid: 'Nie opłacono',
    paymentFor: 'Opłacenie miesiąca',
    inProgress: 'w trakcie. Poinformujemy Cię o statusie transakcji.',
    billingPeriodRepaymentFailedh2: 'Pobranie środków nie powiodło się.',
    billingPeriodRepaymentFailed:
      'Sprawdź środki na koncie lub aktywność karty. W razie problemów skontaktuj się poprzez formularz pomocy.',
    billingPeriodRepaid: 'Trasakcja zakończona sukcesem.',
    partialyPaidInfo1: 'CZĘŚCIOWO opłacono okres rozliczeniowy',
    partialyPaidInfo2:
      'Doładuj konto lub dodaj kartę kredytową w celu dopłaty. W razie problemów skontaktuj się poprzez formularz pomocy.',
    awaitingPayment: 'Oczekiwanie na pobranie płatności',
    missingPayment: 'Brak płatności',
    partialPayment: 'Zapłacono',
    payNow: 'OPŁAĆ',
    payExtraNow: 'DOPŁAĆ',
    payment: 'Wpłata',
    showLess: 'Pokaż mniej',
    showMore: 'Pokaż więcej',
    prepaidBalance: 'Saldo Prepaid',
    balance: 'Saldo',
    promocodeBalance: 'Saldo Promocode',
    activationDate: 'Data aktywacji',
    code: 'Kod',
    expenditureAndCodeValue: 'Zużycie i wartość kodu',
    validUntil: 'Ważne do',
    amountUsed: 'Wykorzystana kwota',
    viewReportFrom: 'Wyświetl raport z',
    orSelectADateRange: 'zakres dat',
    downloadTheReport: 'Pobierz raport',
  },
  creditCards: {
    expirationMonth: 'Ważność karty, miesiąc',
    expirationYear: 'Ważność karty, rok',
    contactInfo: 'Proszę skontaktuj się z nami używając formularza kontaktowego.',
    disclaimer: 'Oświadczam, że zapoznałem(am) się i akceptuję {policyLink} i {termsLink}',
    policyLink: 'Politykę Prywatności',
    termsLink: 'Regulamin',
    successfullyAdded: 'Dodanie karty kredytowej zakończone powodzeniem.',
    successInfo:
      'Opłaty będą pobierane tylko za zasoby, których używasz. Aby sprawdzić swoje aktualne koszty przejdź do sekcji w USTAWIENIA WORKSPACE / ROZLICZENIA.',
    failDuringSubmit: 'Nie można zweryfikować informacji o karcie kredytowej.',
    failInfo:
      'Transakcja zakończona niepowodzeniem. Twoja karta kredytowa nie została dodana i nie zostanie obciążona. Skontaktuj się z nami korzystając z FORMULARZA POMOCY.',
    failPossibleIssues: 'Możliwe przyczyny powstania błędu',
    expired: 'Karta nieważna (wygasła)',
    blocked: 'Karta jest zablokowana',
    noFunds: 'Pobieranie środków z karty jest zablokowane',
  },
  users: {
    roleSelect: {
      owner: 'WŁAŚCICIEL',
      admin: 'ADMINISTRATOR',
      operator: 'OPERATOR',
      read_only: 'TYLKO DO ODCZYTU',
    },
    email: 'E-mail',
    name: 'Nazwa użytkownika',
    invited: 'zaproszony - nieaktywowany',
    user: 'Użytkownik',
    users: 'Użytkownicy',
    inviteNewUser: 'ZAPROŚ NOWEGO UŻYTKOWNIKA',
    role: 'Rola',
    changeRole: 'ZMIEŃ ROLĘ',
    accessToBilling: 'Dostęp do billingu',
    newUser: 'Nowy użytkownik',
    emailToThePerson: 'Podaj adres e-mail osoby, którą chcesz dodać',
    logInAgain: 'Zaloguj się ponownie',
    invalidInvitationToken: 'Nie udało się odnaleźć zaproszenia.',
    clickAgain: 'Kliknij przycisk poniżej, zeby zaakceptować zaproszenie do przestrzeni roboczej',
    accept: 'Zaakceptuj',
  },
  logs: {
    logs: 'Logi',
    selectADateRange: 'Wybierz zakres dat',
    downloadCSV: 'POBIERZ W CSV',
    daysAgo: 'dni temu',
    success: 'Powodzenie',
    fail: 'Błąd',
    running: 'W trakcie',
    pending: 'W oczekiwaniu',
    emptyView: 'Brak logów.',
  },
  routing: {
    description:
      ' Routing pozwala wybrać wychodzący publiczny adres IP dla każdej sieci prywatnej lub indywidualnej karty sieciowej.',
    info:
      'Adres ten będzie widoczny jako źródłowy dla usług zewnętrznych gdy połączenie zostanie zainicjowane z wewnątrz chmury.',
  },
  activation: {
    inactiveWorkspaceExists: 'Aktualnie posiadasz już nieaktywny workspace. Prosimy aktywuj go najpierw.',
    request: 'ZAPYTANIE',
    startCodeInfo: 'Wpisz kod startowy uzyskany od dostawcy usługi.',
    trialCode: 'KOD STARTOWY',
    activatedWorkspace: 'Aktywowano workspace',
    chooseTrialActivationMethod: 'Wybierz metodę aktywacji okresu próbnego',
    hasBeenActivated: '',
    workspacePaymentInfo: 'Opłaty za wykorzystanie zasobów zostaną naliczone i ściągnięte z karty na koniec miesiąca.',
    checkMail: 'Wiadomość została przesłana. Sprawdź skrzynkę pocztową.',
    resendInfo: 'Konto już istnieje, jednak nie zostało aktywowane.',
    ActivateRegion: 'Aktywuj region',
    countryCode: 'Numer kierunkowy kraju',
    switchRegion: 'Przełącz region',
    inactiveRegions: 'Nieaktywne regiony',
    chooseToActivate: '(wybierz aby aktywować)',
    actualLocation: 'to rzeczywista lokalizacja Twojej infrstruktury',
    favorableRegionInfo: 'Najkorzystniejszy region to ten zlokalizowany blisko użytkowników docelowych',
    regionInfraProcessing: 'Trwa przetwarzanie budowy infrastruktury regionu.',
    regionActivationError: 'Wystąpił błąd podczas aktywacji/deaktywacji regionu',
    activationProcess: '',
    invalidLink:
      'Link aktywacyjny jest nieważny. Prawdopodobnie używasz go po raz drugi, a konto zostało już aktywowane.',
    goToThePortal: 'Przejdź do portalu',
    choosePaymentMethod: 'Wybierz metodę płatności i aktywuj workspace',
    youGetToUse: 'Otrzymujesz',
    useThePromocode: 'Wykorzystaj kod startowy w celu aktywacji okresu próbnego.',
    paymentWillBeAutomaticallyTaken: 'Należność będzie automatycznie pobierana z Twojej karty.',
    payOnline: 'ZAPŁAĆ ONLINE',
    payWithPayU: 'zapłać z góry za pomocą PayU',
    youDontHavePromoCode: 'NIE MASZ KODU STARTOWEGO?',
    promoCodeInfo: 'Wyślij zapytanie o aktywację okresu próbnego.',
    trialContactRequest: 'Proszę o kontakt w sprawie aktywacji okresu próbnego.',
    trialMessageSent: 'Wysłano zapytanie o możliwość aktywacji okresu próbnego.',
    nameAndSurnameOnCard: 'Imię i nazwisko na karcie',
    cardNumber: 'Numer karty',
    cardValidity: 'Ważność karty',
    newWorkspace: 'Nowy workspace',
    registerToOneStepCloud: 'Zarejestruj się do One Step Cloud',
    repeatPassword: 'Powórz hasło',
    thanks: 'Dziękujemy!',
    onEMailAdress: 'Na adres',
    sendEMailInfo: 'wysłaliśmy wiadomość e-mail z linkiem aktywujacym konto.',
    enterTheActivationCode: 'Wpisz kod aktywacyjny',
    didntGetActivationLink: 'Nie dostaleś wiadomości z linkiem aktywacyjnym?',
    trial: 'OKRES PRÓBNY',
    smsActivationEmail: 'Aby aktywować okres próbny panelu podaj numer telefonu do weryfikacji.',
    smsActivationEmailCall: 'Za chwilę wyślemy WIADOMOŚĆ GŁOSOWĄ na podany numer DYKTUJĄC KOD STARTOWY.',
    smsActivationEmailWarning: 'Możesz zawnioskować TYLKO RAZ na POLSKI numer telefonu.',
    theSamePhoneNumValidationInfo:
      'Ten numer telefonu został już użyty do aktywowania okresu próbnego. Podaj inny numer.',
    phoneNum: 'Numer telefonu',
    sendVoiceMessage: 'WYŚLIJ WIADOMOŚĆ GŁOSOWĄ',
    voiceMessage: 'Wiadomość głosowa',
    enterCode: 'Wpisz kod',
    DidntReceiveSMS: 'Nie otrzymałeś SMSa z kodem?',
    useAtLeast: 'Użyj co',
    eightCharacters: 'najmniej ośmiu znaków',
    including: ', w tym jednocześnie',
    lettersNumbersSymbols: 'liter, cyfr i symboli',
    welcomeInOnestepCloud: 'Witaj w panelu One Step Cloud!',
    welcomeMessage:
      'Twoje konto jest już aktywne. Możesz teraz stworzyć pierwszy Workspace, czyli przestrzeń w ktorej zbudujesz swoją infrastrukturę maszyn.',
    createWorkspace: 'STWÓRZ WORKSPACE',
    addNewWorkspace: 'DODAJ NOWY WORKSPACE',
    regionError: 'Wystąpił błąd podczas ustawiania regionu.',
    returnToHomepage: 'Wróć do strony głównej',
    successfullyApprovedNew: 'Pomyślnie potwierdzono nowy adres email',
    successfullyApprovedOld: 'Pomyślnie potwierdzono zmianę adresu na starym adresie',
    useLink: 'Użyj linku, który przyszedł na',
    old: 'stary',
    new: 'nowy',
    completeChange: 'adres, aby dokończyć proces zmiany adresu email.',
    successfullyChanged: 'Pomyślnie zmieniono adres email,',
    logIn: 'zaloguj się',
    logInUsingNew: 'ponownie używając nowego adresu email.',
    newWorkspaceInfo:
      'Workspace to miejsce, w którym członkowie zespołu mogą współpracować. Jeśli Twój zespół jest już na One Step Cloud, musisz otrzymać zaproszenie i zaakceptować je.',
    workspaceInfo:
      'Workspace (środowisko pracy) umożliwia współpracę zespołowi. Role dla użytkowników, zapewniają ograniczenie ich uprawnień. Możesz zakładać środowiska produkcyjne, testowe, deweloperskie lub tworzyć je per projekt.',
    invitations: 'Zaproszenia',
    workspaces: 'Workspace',
    infoAfterPromocodeRequest: 'Dziękujemy! Wkrótce skontaktujemy się z Tobą w celu aktywacji okresu próbnego.',
  },
  removeDialog: {
    areYouSure: 'Czy na pewno?',
    createSnapshot: 'Czy jesteś pewny, że chcesz stworzyć snapshot?',
    restoreSnapshot: 'Czy jesteś pewny, że chcesz przywrócić snapshot?',
    removeSnapshot: 'Czy jesteś pewny, że chcesz usunąć snapshot?',
    wantToRemove: 'Czy na pewno chcesz usunąć',
    wantToDeleteDedicatedMachine: 'Czy na pewno chcesz zrezygnować z maszyny dedykowanej?',
    minimumRentalTime: 'Jeżeli nie przekroczono minimalnego czasu najmu, zostanie naliczona opłata do jego wartości.',
    wantToRemoveInvitation: 'Czy na pewno chcesz usunąć zaproszenie?',
    wantToRemoveUser: 'Czy na pewno chcesz usunąć użytkownika?',
    wantToRemoveNetworkCard: 'Czy na pewno chcesz usunąć kartę sieciową?',
    wantToResignIpAddress: 'Czy na pewno chcesz zrezygnować z publicznego adresu IP',
    wantToRemoveNats: 'Czy na pewno chcesz usunąć wybrane mapowania NAT?',
    associatedFirewall: 'usuń powiązane reguły firewall',
  },
  workspace: {
    create: 'Utwórz nowy workspace',
    blocked: 'Zablokuj workspace',
    block: 'Zablokuj workspace',
    unblock: 'Odblokuj workspace',
    admin_block: 'Zablokuj workspace administracyjnie',
    admin_unblock: 'Odblokuj workspace administracyjnie',
    closed: 'Usuń workspace',
    console_policy_updated: 'Zaktualizuj prawa dostępowe do konsoli',
    activate: {
      promocode: 'Aktywacja workspace (promocode)',
      prepaid: 'Aktywacja workspace (prepaid)',
      contract: 'Aktywacja workspace (umowa)',
      trial: 'Aktywacja workspace (okres próbny)',
    },
  },
  trial: {
    converted: 'Wystąpiła konwersja triala i zaktualizowano metodę płatności',
  },
  virtual_machine: {
    backup_activated: 'Aktywowano tworzenie kopii zapasowej dla {name} ({id})',
    backup_deactivated: 'Deaktywowano tworzenie kopii zapasowej dla {name} ({id})',
    create: 'Utworzenie maszyny wirtualnej {name} ({id})',
    update: 'Zapisanie zmian w maszynie wirtualnej {name} ({id})',
    power_on: 'Włączenie maszyny wirtualnej {name} ({id})',
    power_off: 'Wyłączenie maszyny wirtualnej {name} ({id})',
    suspend: 'Uśpienie maszyny wirtualnej {name} ({id})',
    restart: 'Ponowne uruchomienie maszyny wirtualnej {name} ({id})',
    destroy: 'Usunięcie maszyny wirtualnej {name} ({id})',
    console_access_granted: 'Zagwarantuj dostęp do konsoli dla {name} ({id})',
    hardware: { update: 'Aktualizacja hardware maszyny wirtualnej {name} ({id})' },
    snapshot: {
      create: 'Utworzenie snapshotu na maszynie wirtualnej {name} ({id})',
      destroy: 'Usunięcie snapshotu na maszynie wirtualnej {name} ({id})',
      restore: 'Przywrócenie snapshotu na maszynie wirtualnej {name} ({id})',
    },
    nic: {
      create: 'Dodanie karty sieciowej {name} do maszyny {virtual_machine_name} ({virtual_machine_id})',
      update: 'Aktualizacja karty sieciowej {name} w maszynie {virtual_machine_name} ({virtual_machine_id})',
      destroy: 'Usunięcie karty sieciowej {name} z maszyny {virtual_machine_name} ({virtual_machine_id})',
    },
  },
  usage_limit: {
    updated: 'Zaktualizuj limity zużycia',
  },
  dm_reservation: {
    requested: 'Rezerwacja maszyny dedykowanej',
    update: 'Aktualizacja maszyny dedykowanej',
    create: 'Rezerwacja maszyny dedykowanej',
    destroy: 'Rezygnacja z maszyny dedykowanej',
    power_on: 'Włączenie maszyny dedykowanej',
    power_off: 'Wyłączenie maszyny dedykowanej',
    reset: 'Ponowne uruchomienie maszyny dedykowanej',
    nic: {
      update: 'Aktualizacja karty sieciowej maszyny dedykowanej',
    },
  },
  vpn_user: { create: 'Utworzenie użytkownika VPN', destroy: 'Usunięcie użytkownika VPN' },
  private_network: {
    create: 'Utworzenie sieci prywatnej {name}',
    update: 'Aktualizacja sieci prywatnej {name}',
    destroy: 'Usunięcie sieci prywatnej {name}',
    update_name: 'Zmiana nazwy sieci prywatnej',
  },
  public_ip_address: {
    create: 'Dodanie publicznego adresu IP {ip_address}',
    destroy: 'Usunięcie publicznego adresu IP {ip_address}',
    resign: 'Rezygnacja z publicznego adresu IP {ip_address}',
    reserve: 'Rezerwacja publicznego adresu IP',
  },
  workspace_region: {
    destroy: 'Deaktywacja regionu {name}',
  },
  nat: { create: 'Dodanie mapowania NAT', bulk_destroy: 'Usunięcie mapowania NAT' },
  firewall_rules: { update: 'Zapisanie nowej konfiguracji firewall' },
  region: { activate: 'Aktywacja regionu {name}', deactivate: 'Deaktywacja regionu {name}' },
  user: {
    destroy: 'Usunięcie użytkownika {name} ({email})',
    update: 'Aktualizacja użytkownika',
    invitation: {
      create: 'Wysłanie zaproszenia do {email}',
      accept: 'Akceptacja zaproszenia od ({name}, {email})',
      destroy: 'Anulowanie zaproszenia dla {email} anulowane',
    },
  },
  vpn: {
    noVPNUsers: 'Brak użytkowników VPN',
    addFirstUser: 'Dodaj pierwszego użytkownika VPN',
    manageUsers: 'Zarządzaj użytkownikami VPN i udostępniaj zasoby Twojego workspace.',
    insufficentPermissions: 'Brak możliwości zarządzania użytkownikami VPN dla roli „tylko do odczytu".',
    invalidUuid: 'Identyfikator użytkownika jest nieprawidłowy. Skontaktuj się z nami, aby uzyskać więcej informacji.',
    loading: 'Trwa pobieranie...',
  },
  firewall: {
    noFirewallRules: 'Brak zasad firewall',
    addFirstFIrewallRule: 'Dodaj pierwszą regułę firewall',
    manageFirewallRules:
      'Domyślnie firewall nie zawiera żadnych zasad. Firewall jest usługą globalną dla regionu, nie ma w nim podziału na sieci, maszyny etc. Firewall jest usługą niezależną od reszty infrastruktury i w pełni zarządzaną przez Ciebie.',
  },
  sms: {
    deliveryFailed: 'Z winy operatora wysyłka wiadomości głosowej nie powiodła się. Spróbuj ponownie później.',
    limitReached: 'Został osiągnięty limit wiadomości głosowych. Prosimy o kontakt.',
    confirmationRequired:
      'Nie udało się wygenerować nowego kodu, ponieważ istnieje już numer telefonu na który przesłano kod. Wpisz poniżej otrzymany kod.',
    confirmed: 'Numer telefonu jest już potwierdzony.',
    confirmedPhoneNumber: 'Wysłano wiadomość głosową z kodem potwierdzającym na numer',
    enterTheConfirmationCode: 'Wpisz kod potwierdzający.',
    invalidConfirmationCode: 'Kod potwierdzający jest błędny.',
    expiredCode: 'Kod potwierdzający stracił ważność.',
    eligitable: 'Ponowna aktywacja jest niemożliwa. Podanym numerem aktywowano już jednorazowy okres próbny.',
  },
  faq: {
    gt: 'PODSTAWOWE INFORMACJE',
    gq1: 'Kim jesteśmy?',
    ga1:
      'One Step Cloud jest produktem Intratel – firmy integratorskiej z doświadczeniem sięgającym 1997 roku.\n' +
      '            Jesteśmy ekspertami rozwiązań z zakresu bezpieczeństwa i dostępności danych. Dostarczamy, integrujemy i\n' +
      '            wdrażamy technologie informatyczne wiodących producentów, jesteśmy m.in. partnerem VMware oraz Platynowym\n' +
      '            Partnerem Dell. Więcej o naszych usługach, możliwościach technicznych i inżynierskim zapleczu dowiesz się na\n' +
      '            Intratel.pl',
    gq2: 'Czym jest chmura One Step Cloud?',
    ga2:
      'Chmura One Step Cloud to sposób na elastyczne korzystanie z zasobów komputerowych bez konieczności kupowania\n' +
      '            własnej infrastruktury i utrzymywania jej. Z zasobów takich jak procesory, pamięć czy przestrzeń dyskowa w\n' +
      '            One Step Cloud korzystać można poprzez prosty w obsłudze portal, łatwo zmieniając wielkość i poziom\n' +
      '            wykorzystania zasobów. One Step Cloud pozwala także na stworzenie chmury hybrydowej. W tym modelu zasoby\n' +
      '            klienta są integrowane z zasobami naszego Data Center. Tak zintegrowane zasoby można wykorzystać do\n' +
      '            bezpiecznego przetwarzania danych, uruchamiania aplikacji, systemów i usług będących własnością klienta.',
    gq3: 'Czy posiadacie w swojej ofercie maszyny dedykowane? Jakie?',
    ga3:
      'Tak, Posiadamy w swojej ofercie maszyny dedykowane. Jest możliwość wynajmowania ich na godziny, po ustaleniu\n' +
      '            określonych warunków współpracy. Są to maszyny wyposażone w pamięć GPU, STICK, Akcelerator, FPGA lub PCIE,\n' +
      '            które są pomocne przy pracy z AI. Aby wynająć maszynę dedykowaną - zawnioskuj do nas poprzez formularz\n' +
      '            pomocy wybierając "Dedykowane maszyny - wniosek" i określ szczegóły, a my się zajmiemy resztą.',
    gq4: 'Co jeśli nie będę zadowolony z waszych usług? Czy mogę się wycofać?',
    ga4:
      'Tak, w każdej chwili, po uregulowaniu należności możesz usunąć konto. Dodatkowo nasza chmura bazuje na\n' +
      '            VMware – na którym tworzą Państwo swoje serwery. W każdym momencie można przenieść wszystkie swoje zasoby do\n' +
      '            innej chmury lub zainstalować fizycznie w firmie na własnym sprzęcie fizycznym - serwerach i macierzach.',
    gq5: 'Co was wyróżnia od konkurencji?',
    ga5t1: 'Data Center w Polsce i USA',
    ga5d1:
      'Nasze Data Center są zlokalizowane w Polsce oraz USA. Spełniają wysokie normy bezpieczeństwa gwarantowane\n' +
      '            m.in. certyfikatami ISO.',
    ga5t2: 'Opieka inżynierska',
    ga5d2:
      'One Step Cloud bazuje na wieloletnim i szerokim doświadczeniu inżynierów Intratel. Gwarantujemy wsparcie w\n' +
      '            migracji całej infrastruktury w cenie oraz wsparcie specjalistów w zakresie nie tylko chmury, ale też sieci.\n' +
      '            Zawsze dostępni i zaangażowani.',
    ga5t3: 'Udostępnienie API',
    ga5d3:
      'One Step Cloud posiada API dzięki któremu można automatyzować działania środowisk i maszyn. Dzięki temu\n' +
      '            możemy ograniczać koszty wykorzystywanych zasobów.',
    ga5t4: 'Uczciwe zasady',
    ga5d4:
      'Nie ograniczamy wykorzystania infrastruktury. Nie zmniejszamy wydajności w trakcie nadmiernego korzystania\n' +
      '            ze sprzętu, by zmusić klienta do zakupienia większych zasobów. Posiadamy możliwość zarządzania centralnego.\n' +
      '            Jasne zasady rozliczania. Dajemy możliwość bezpłatnego wypróbowania infrastruktury. Udostępniamy także API\n' +
      '            do zarządzania środowiskiem, by finalnie klient mógł korzystać tylko ze sprzętu w określonych godzinach,\n' +
      '            kontrolując swoje koszty.',

    wt: 'ŚRODOWISKO PRACY (WORKSPACE)',
    wq1: 'Co to jest workspace?',
    wq2: 'Jakie możliwości daje mi workspace?',
    wq3: 'Jak mogę nadać uprawnienia do mojego workspace?',
    wq4: 'Jakie są uprawnienia odpowiednich ról?',
    wa1:
      'Workspace (środowisko pracy) umożliwia współpracę zespołowi. Role dla użytkowników, zapewniają ograniczenie ich uprawnień. Możesz zakładać środowiska produkcyjne, testowe, deweloperskie lub tworzyć je per projekt.',
    wa2:
      'Workspace jest osobnym bytem. Możesz wybrać walute, dane do faktury, określić system płatności. Możesz także zaprosić odrębnie osoby do współprac lub być zaproszonym do czyjegoś środowiska pracy.',
    wa3:
      'Możesz zaprosić współpracowników wysyłając im zaproszenie poprzez portal oraz określić ich odpowiednią rolę, która zdefiniuje jakie uprawnienia będą posiadać. Wszystkie te akcje możesz wykonać w ustawieniach workspace zakładka użytkownicy.',
    wa4t1: 'Właściciel',
    wa4d1:
      'Właściciel to rola, którą otrzymuje się automatycznie po założeniu workspace. Ma on uprawnienia do wszystkiego, w szczególności do:\n',
    wa4d1ada: 'nadania innemu użytkownikowi roli właściciela,',
    wa4d1adb: 'usunięcia innego użytkownika z rolą właściciela,',
    wa4d1adc: 'usunięcia workspace,',
    wa4d1add: 'zmiany nazwy workspace.',
    wa4t2: 'Administrator',
    wa4d2:
      'Rola Administrator daje uprawnienia do wszystkiego poza szczególnymi uprawnieniami roli Właściciel. Administrator może np aktywować regiony, zarządzać infrastrukturą, dodawać nowych użytkowników, zmienić nazwę workspace’u, zarządzać płatnościami.',
    wa4t3: 'Operator',
    wa4d3:
      'Rolę Operator nadajemy gdy chcemy dać komuś dostęp jedynie od zarządzania infrastrukturą (maszyny wirtualne, sieci itp.).',
    wa4t4: 'Tylko do odczytu',
    wa4d4: 'Ta rola pozwala na przeglądanie workspace’u, ale nie na dokonywanie jakichkolwiek zmian czy akcji.',

    st: 'DYSKI',
    sq1: 'Czy mogę zmieniać pojemność dysków w trakcie miesiąca?',
    sa1t1: 'Możesz:',
    sa1d1: 'Zwiększać pojemność dysków.',
    sa1t2: 'Nie możesz:',
    sa1d2:
      'Zmniejszać pojemności dysków. Mogłoby to spowodować utratę danych. Alternatywą jest dodanie nowego dysku o mniejszej pojemności, zmigrowanie danych i usunięcie większego dysku z maszyny.',

    sq2: 'Czy mogę usuwać / dodawać dyski w trakcie miesiąca?',
    sa2:
      'Tak, można dodawać i usuwać dyski. Przed usunięciem dysku upewnij się, że nie znajdują się na nim żadne ważne dane, ponieważ po usunięciu nie będzie można ich odzyskać.',

    sq3: 'Jakie rodzaje dysków są dostępne?',
    sa3: 'One Step Cloud oferuje dyski HDD, SSD i biblioteki taśmowe wykorzystywane przy kopii zapasowej.',

    sq4: 'Czy mogę dodać mój dysk do wirtualnej maszyny?',
    sa4:
      'Tak. Wystarczy złożyć zapytanie, a my dodamy Twój dysk do wirtualnej maszyny i będzie on dostępny w wirtualnej maszynie.',

    nt: 'SIEĆ',
    nq1: 'Ile adresów IP udostępniacie użytkownikom?',
    na1:
      'Udostępniamy jeden publiczny adres IP do każdego Regionu w każdym workspace. Dodatkowo można dokupić publiczne adresy IP w celu przypisania go do każdej maszyny wirtualnej. Ceny są zawarte w kalkulatorze.',

    nq2: 'Czy mogę ustawić rekord reverse DNS?',
    na2: 'W One Step Cloud nie ma możliwości ustawienia rekordu reverse DNS.',

    nq3: 'Czy są limity VPN?',
    na3:
      'Nie ma limitów VPN. Natomiast jeśli użytkownik potrzebuje powyżej 100 użytkowników, należy skonsultować się z nami, czy bardziej efektywne byłoby stworzenie VPN przez klienta. VPN jest przydzielony do regionu w danym workspace.',

    nq4: 'Jakie regiony mogę wybrać i jakie to ma znaczenie?',
    na4:
      'Można wybrać regiony zlokalizowane w Polsce oznaczone przedrostkiem "PL" lub z przedrostkiem "USA"\n' +
      '            (lokalizacja Santa Clara, Stany Zjednoczone Ameryki Północnej). W momencie wyboru regionu decydujemy się na\n' +
      '            fizyczne przechowywanie danych w danym regionie, co wiąże się z opłatami na podstawie danej lokalizacji.\n' +
      '            Polecamy założenie wirtualnej maszyny w regionie, który będzie najbliżej użytkownika końcowego.',

    bt: 'ROZLICZENIA',
    bq1: 'Jakie formy płatności są akceptowane?',
    ba1:
      'Akceptujemy wszystkie podstawowe formy płatności takie jak Visa, MasterCard, Maestro, American Express i\n' +
      '            inne. Więcej informacji najdziecie tutaj: https://paylane.pl/metody-platnosci/ . Jest także możliwość\n' +
      '            dokonania przedpłaty lub rozliczania się na podstawie umowy i wystawianej faktury. Więcej szczegółów\n' +
      '            dostępnych po kontakcie z przedstawicielem firmy.',

    bq2: 'Jak naliczane są opłaty za wykorzystanie zasobów?',
    ba2:
      'Przy tworzeniu workspace, wybierasz walutę. Wybierasz formę prawną i wpisujesz dane firmowe oraz formę\n' +
      '            płatności, która będzie stosowana dla danego środowiska pracy. Płacisz w rozliczeniu sekundowym, a moment\n' +
      '            rozliczenia następuje na koniec miesiąca kalendarzowego. Płacisz tylko za to, co wykorzystałeś.',

    bq3: 'Czy jestem obciążany w momencie gdy moja maszyna jest wyłączona?',
    ba3:
      'W momencie wyłączenia maszyny nie płacisz za moc obliczeniową (vCPU) i pamięć operacyjną (RAM). Natomiast opłaty takie jak licencja za system operacyjny lub dodatkowy publiczny adres IP są naliczane przez cały czas istnienia.',

    bq4: 'Jak jestem obciążany za zasoby?',
    ba4: 'Ceny zasobów są podane podczas tworzenia maszyny wirtualnej. Opłata naliczana jest w rozliczeniu sekundowym.',

    bq5: 'Jak są rozliczane opłaty za systemy operacyjne np. Windows Serwer?',
    ba5:
      'Opłaty za system operacyjny naliczane są co sekundę. Płacisz za tyle sekund ile jest stworzona twoja maszyna wirtualna. Wstrzymanie i wyłączenie maszyny nie powoduje zmniejszenia kosztów.',

    bq6: 'Jak rozliczany jest promokod?',
    ba6: 'Promokod zwiększa saldo danego workspace. Może być on wykorzystany tylko raz w danym workspace.',

    bq7: 'Jak działa okres próbny?',
    ba7:
      'Okres próbny służy do sprawdzenia funkcjonalności portalu. Może być użyty tylko jeden raz przez danego użytkownika podającego określony numer telefonu. Okres próbny trwa 30 dni. Po tym czasie workspace jest blokowany. Aby uniknąć blokady, należy aktywować jedną z dostępnych metod płatności.',
  },
  helpForm: {
    title: 'Formularz pomocy',
    header: 'Zgłoś błąd lub wniosek',
    sendBtn: 'WYŚLIJ',
    uploadFile: 'Dodaj plik (jpg, png)',
    descriptionOne:
      'Naszym celem jest zapewnienie najbardziej przyjaznej platformy do wirtualnego centrum danych. Oficjalna dokumentacja znajduje się tutaj',
    descriptionTwo: 'Jeśli chcesz nam o czymś powiedzieć, prosimy skontaktuj się przez formularz.',
    descriptionThree: 'Zrobimy co w naszej mocy, by szybko odpowiedzieć na Twoje zgłoszenie.',
    ticketCreated: 'Utworzono zgłoszenie.',
    documentationInfo:
      'W razie jakichkolwiek wątpliwości lub w celu uzyskania dodatkowych informacji prosimy o skorzystanie z dokumentacji',
    supportInfo:
      'Po wysłaniu zgłoszenia, otrzymasz informację potwierdzającą przesłanie wiadomości. Postaramy się wrócić do Ciebie z pomocą w jak najkrótszym czasie. Wsparcie i kontakt z działem technicznym odbywa się wyłacznie poprzez e-mail.',
    docsLink: 'http://docs.onestepcloud.pl',
    error: 'Błąd',
    usersIssue: 'Problem z dostępami / zaproszeniami / użytkownikami',
    slaRequest: 'Zgłoszenie SLA',
    unlock: 'Odblokowanie workspace',
    newFeature: 'Pomysł, nowe rozwiązanie',
    backup: 'Kopia zapasowa',
    customDM: 'Dedykowane maszyny - wniosek',
    customOS: 'Dodatkowy system operacyjny',
    resources: 'Zasoby - zwiększenie limitów',
    consoleAccess: 'Dostęp do konsoli wirtualnej maszyny',
    vmDiskImport: 'Import dysku do wirtualnej maszyny',
    billingSupport: 'Rozliczenia - wsparcie',
    vmSupport: 'Wirtualne maszyny - import / wsparcie',
    networkSupport: 'Sieć - wsparcie',
    other: 'Inne',
    descriptions: {
      error: '',
      usersIssue: '',
      slaRequest:
        ' * Kiedy nastąpiła niedostępność? \n' +
        ' * Kiedy zakończyła się niedostępność?\n' +
        ' * Co było niedostępne?\n' +
        ' * Dodatkowe informacje:',
      unlock:
        'Proszę o informację jak mogę odblokować workspace.\n' +
        ' * Nazwa workspace:\n' +
        ' * Numer telefonu do kontaktu:\n' +
        ' * Adres e-mail:\n',
      newFeature: '',
      backup:
        'Proszę o kopię zapasową mojej wirtualnej maszyny.\n' +
        ' * Nazwa wirtualnej maszyny:\n' +
        ' * Dzień rozpoczęcia tworzenia kopii zapasowej:',
      customDM:
        'Jestem zainteresowany wynajęciem maszyny dedykowanej. Poniżej szczegóły:\n' +
        ' * Nazwa systemu operacyjnego:\n' +
        ' * Wersja systemu operacyjnego:\n' +
        ' * Oczekiwana ilość CPU/GPU: \n' +
        ' * Oczekiwana ilość pamięci operacyjnej RAM: \n' +
        ' * Oczekiwana ilość przestrzeni dyskowej: \n' +
        ' * Oczekiwana ilość czasu pracy (godziny / dni): \n' +
        ' * Dodatkowe informacje (n.p. STICK, Akcelerator, FPGA, PCIE):',
      customOS:
        'Chciałbym zainstalować inny system operacyjny na mojej maszynie wirtualnej, który nie jest aktualnie dostępny na One Step Cloud. Poniżej szczegóły:\n' +
        ' * Nazwa systemu operacyjnego:\n' +
        ' * Wersja systemu operacyjnego:\n' +
        ' * ISO pobrania URL:\n' +
        ' * Dodatkowe informacje (n.p. język):',
      resources:
        'Proszę o zwiększenie limitów w moim workspace minimalnie do wartości:\n' +
        ' * Oczekiwana ilość vCPU: \n' +
        ' * Oczekiwana ilość pamięci operacyjnej RAM: \n' +
        ' * Oczekiwana ilość przestrzeni dyskowej: \n' +
        ' * Oczekiwana ilość publicznych adresów IP: \n',
      consoleAccess:
        'Proszę o dostęp poprzez konsolę do mojej wirtualnej maszyny.\n' +
        ' * ID oraz nazwa wirtualnej maszyny:\n' +
        ' * Telefon kontaktowy:',
      vmDiskImport:
        'Chciałbym zaimportować dysk do wirtualnej maszyny na One Step Cloud. Poniżej szczegóły wymagane do importu:\n' +
        ' * Szacowana wielkość dysku dołączanego do wirtualnej maszyny (po eksporcie):\n' +
        ' * Typ pliku eksportowego:\n' +
        ' * Nazwa wirtualnej maszyny:',
      billingSupport: '',
      vmSupport:
        'Chciałbym zaimportować wirtualną maszynę do One Step Cloud. Poniżej szczegóły.\n' +
        ' * System Operacyjny wirtualnej maszyny:\n' +
        ' * Szacowana wielkość wirtualnej maszyny (po eksporcie):\n' +
        ' * Dotychczasowa technologia wirtualizacji (albo dostawca chmury):\n' +
        ' * Typ pliku eksportowego:\n' +
        ' * Nazwa wirtualnej maszyny:',
      networkSupport: '',
      other: '',
    },
  },
  costBilledPerSecond: 'Koszt rozliczany sekundowo.',
  backupConfirmationInfoPart1: 'Chcesz rozpocząć tworzenie kopii zapasowej dla tej maszyny?',
  backupConfirmationInfoPart2:
    'Twoja kopia zapasowa będzie wykonywana codziennie począwszy od następnego dnia roboczego.',
  backupConfirmationInfoPart3: 'Opłata za kopię zapasową składa się z:',
  backupConfirmationInfoPart4: 'miesięcznej opłaty stałej w wysokości',
  backupConfirmationInfoPart5: 'za maszynę',
  backupConfirmationInfoPart6: 'dodatkowej opłaty uzaleznionej od wielkości przestrzeni Twojej maszyny:',
  backupConfirmationInfoPart7: 'za',
  backupConfirmationInfoPart8: 'Jakiekolwiek zmiany polityki kopii zapasowej wymagają kontaktu z serwisem.\n',
  name_invalid: 'Proszę uzupełnij formularz.',
  forbidden_last_owner: 'Wymagany minimum jeden Właściciel w workspace.',
  workspace_with_contract:
    'Została zawarta umowa (oferta indywidualna). Skontaktuj się z nami w celu rozwiązania umowy.\n',
  outstanding_debt_exists: 'Istnieją nieopłacone okresy rozliczeniowe.\n',
  trial_code_invalid: 'Kod startowy jest niepoprawny lub stracił ważność.\n',
  trial_code_used: 'Kod startowy został już wykorzystany.\n',
  trial_used: 'Opcja trial została już wykorzystana.\n',
  public_ip_address_in_use: 'Nie można usunąć adresu publicznego, ponieważ jest on używany.\n',
  inactive_workspace: 'Nieaktywny workspace.\n',
  blocked_workspace: 'Zablokowany workspace.\n',
  snapshot_exists: 'Przed zmianą ustawień sprzętowych usuń snapshot.\n',
  region_not_activated: 'Region nie został aktywowany/deaktywowany (akcja nie powiodła się).\n',
  blacklisted: 'Podany adres email lub numer telefonu jest na naszej czarnej liście.',
  token_invalid: 'Nieważny token.',
  fraud_risk_too_high:
    'Numer, który próbujesz użyć, został wykryty jako niebezpieczny. Użyj innego numeru lub skontaktuj się z nami.\n',
  contract_exists:
    'Nie ma możliwości dodania karty w przypadku, kiedy podstawą rozliczeń jest umowa (oferta indywidualna).',
  no_more_public_ip_addresses: 'Chwilowy brak dostępnych adresów IP. Proszę spróbuj później.',
  invalid_token: 'Token jest nieważny.',
  none_unit_available: 'Brak dostępnej maszyny dedykowanej do wynajęcia.',
  trial_active: 'Brak uprawnień do akcji na OKRESIE PRÓBNYM.',
  min_usage_funds_missing: 'Brak wystarczających środków na pokrycie kosztu minimalnego.',
  activation_attempts_limit_exceeded: 'Przekroczono limit możliwych prób wpisania kodu.\n',
  error: {
    primary_disk: {
      invalid: 'Zmniejszanie pojemności dysków jest niemożliwe.',
    },
    private_network: {
      ip_address_not_available: 'Brak wolnego adresu IP w sieci prywatnej.',
    },
    invalid_power_state: 'Niepoprawny stan maszyny. Wymagany stan włączony, wyłączony.',
    invalid_state: 'Niepoprawny stan. Wymagany stan {params}.',
    end_time: {
      incorrect: 'Podana data końca okresu raportu jest nieprawidłowa.',
    },
    role: {
      blank: 'Pole rola jest puste.\n',
      inclusion: 'Brak możliwości zmiany roli.\n',
    },
    phone_number: {
      invalid: 'Niepoprawny format numeru telefonu.\n',
      blank: 'Numer telefonu jest wymagany.\n',
      confirmed: 'Numer telefonu został już wykorzystany w celu potwierdzenia.\n',
      confirmation_required: 'Potwierdzenie jest wymagane.\n',
      invalid_confirmation_code: 'Kod potwierdzający jest niepoprawny.\n',
      not_eligible: 'Tym numerem już aktywowano triala i nie można tego zrobić ponownie.\n',
      blacklisted: 'Nie można wykorzystać podanego numeru telefonu, użyj innego.\n',
      confirmation_attempts_limit_exceeded: 'Przekroczono limit możliwych prób wpisania kodu.\n',
    },
    phone_number_not_found: 'Brak numeru przypisanego do konta.\n',
    name: {
      blank: 'Pole nazwa jest wymagane.\n',
      too_short: 'Pole nazwa jest za krótkie (minimalnie: {count}).\n',
      too_long: 'Pole nazwa jest zbyt długie (maksymalnie: {count}).\n',
    },
    activation_attempts_limit_exceeded: 'Przekroczono limit możliwych prób wpisania kodu.\n',
    power_not_manageable: 'Brak możliwości sterowania zasilaniem.\n',
    blank: 'Należy uzupełnić pola.\n',
    too_short: 'ma za mało znaków (minimalnie: {count}).\n',
    too_long: 'ma za dużo znaków (minimalnie: {count}).\n',
    taken: 'jest już zajęty.\n',
    invalid: 'jest nieważny.\n',
    inclusion: 'jest nieważny.\n',
    not_a_number: 'nie jest liczbą.\n',
    greater_than: 'musi być większe niż {count}.\n',
    greater_than_or_equal_to: 'musi być większe lub równe {count}.\n',
    equal_to: 'musi być równe {count}.\n',
    less_than: 'musi być mniejsze niż {count}.\n',
    less_than_or_equal_to: 'musi być mniejsze lub równe {count}.\n',
    not_an_integer: 'nie jest liczbą całkowitą.\n',
    cpu_cores: {
      limit_reached: 'Przekroczono limit vCPU.\n',
    },
    authorization: {
      invalid: 'Wystąpił problem z autoryzacją.\n',
    },
    username: {
      taken: 'Nazwa użytkownika jest już zajęta.\n',
      invalid: 'Nazwa użytkownika ma niepoprawny format.\n',
    },
    ram: {
      limit_reached: 'Przekroczono limit RAM.\n',
    },
    storage: {
      limit_reached: 'Przekroczono limit dla przestrzeni dyskowej.\n',
    },
    public_networks: {
      limit_reached: 'Przekroczono limit ilości dostępnych sieci publicznych.\n',
    },
    type: {
      blank: 'należy uzupełnić pole.\n',
      too_short: 'ma za mało znaków (minimalnie: {count}).\n',
      inclusion: 'Wybierz typ - firma lub osoba prywatna.\n',
    },
    description: {
      blank: 'należy uzupełnić pole.\n',
      too_short: 'ma za mało znaków (minimalnie: {count}).\n',
    },
    image: {
      file_type_invalid: 'Niepoprawny plik. Załaduj jpg lub png.\n',
      too_big: 'Obraz jest za duży. Maksymalnie 5MB.\n',
    },
    network: {
      collision: 'Koliduje z inną siecią.\n',
      forbidden: 'Zabroniony adres.\n',
    },
    ip_address: {
      collision: 'Koliduje z inną usługą.\n',
    },
    private_network_id: {
      collision: 'Koliduje z inną kartą sieciową.\n',
    },
    email: {
      blank: 'Email jest wymagany.\n',
      invalid: 'Niepoprawny adres email.\n',
      already_invited: 'Użytkownik został już zaproszony.\n',
      taken: 'Adres email jest już zajęty.\n',
      blacklisted: 'Nie można wykorzystać podanego adresu email, użyj innego.\n',
    },
    public_key: {
      not_unique: 'już istnieje.\n',
      invalid: 'Klucz publiczny jest nieprawidłowy.\n',
      blank: 'Klucz publiczny jest wymagany.\n',
    },
    source_port: {
      overlapping: 'pokrywa się z innym NAT.\n',
    },
    destination_port: {
      range_mismatch: 'Niedopasowanie zakresu.\n',
    },
    current_password: {
      invalid: 'Niepoprawne stare hasło.\n',
    },
    password: {
      blank: 'Hasło jest wymagane.\n',
      too_short: 'Hasło jest za krótkie. Wymagane jest minimalnie 8 znaków.\n',
    },
    code: {
      used_by_account: 'Kod został już wykorzystany dla Twojego konta.\n',
      used_in_workspace: 'Kod został już wykorzystany do zasienia konta workspace.\n',
      invalid: 'Kod jest nieważny.\n',
    },
    nic: {
      blank: 'Prywatny adres IP jest wymagany.\n',
    },
    nic_id: {
      not_active: 'Nie ma możliwości utworzenia NAT do niepodłączonej karty sieciowej.\n',
    },
    source_port_range: {
      invalid: 'Źródłowy zakres portów jest niepoprawny.\n',
    },
    destination_port_range: {
      invalid: 'Docelowy zakres portów jest niepoprawny.\n',
    },
    source_ip: {
      blank: 'Źródłowy adres IP jest wymagany.\n',
      invalid: 'Źródłowy adres IP jest niepoprawny.\n',
    },
    destination_ip: {
      blank: 'Docelowy adres IP jest wymagany.\n',
      invalid: 'Docelowy adres IP jest niepoprawny.\n',
    },
    workspaces_exist: 'Najpierw wypisz się z workspace.\n',
    protocol: {
      blank: 'Pole protokół jest wymagane.\n',
      inclusion: 'Włącz protokół.\n',
    },
    city: {
      blank: 'Pole miasto jest wymagane.\n',
      too_short: 'Pole miasto jest za krótkie. Wymagane są minimalnie 2 znaki.\n',
    },
    address: {
      blank: 'Pole adres jest wymagane.\n',
      too_short: 'Pole adres jest za krótkie. Wymagane są minimalnie 2 znaki.\n',
    },
    zip_code: {
      blank: 'Pole kod pocztowy jest wymagane.\n',
      too_short: 'Pole kod pocztowy jest za krótkie. Wymagane są minimalnie 2 znaki.\n',
    },
    tax_id: {
      blank: 'Pole numer identyfikacji podatkowej jest wymagane.\n',
      invalid: 'Pole numer identyfikacji podatkowej jest niepoprawne.\n',
    },
    currency: {
      invalid: 'Pole waluta jest wymagane.\n',
    },
  },
  country: {
    Afghanistan: 'Afganistan',
    ÅlandIslands: 'Wyspy Alandzkie',
    Albania: 'Albania',
    Algeria: 'Algeria',
    AmericanSamoa: 'Samoa Amerykańskie',
    Andorra: 'Andora',
    Angola: 'Angola',
    Anguilla: 'Anguilla',
    Antarctica: 'Antarktyda',
    AntiguaandBarbuda: 'Antigua i Barbuda',
    Argentina: 'Argentyna',
    Armenia: 'Armenia',
    Aruba: 'Aruba',
    Australia: 'Australia',
    Austria: 'Austria',
    Azerbaijan: 'Azerbejdżan',
    Bahamas: 'Bahamy',
    Bahrain: 'Bahrajn',
    Bangladesh: 'Bangladesz',
    Barbados: 'Barbados',
    Belarus: 'Białoruś',
    Belgium: 'Belgia',
    Belize: 'Belize',
    Benin: 'Benin',
    Bermuda: 'Bermudy',
    Bhutan: 'Bhutan',
    Bolivia: 'Wielonarodowe Państwo Boliwia',
    Bonaire: 'Bonaire',
    SintEustatiusandSaba: 'Sint Eustatius i Saba',
    BosniaandHerzegovina: 'Bośnia i Hercegowina',
    Botswana: 'Botswana',
    BouvetIsland: 'Wyspa Bouveta',
    Brazil: 'Brazylia',
    BritishIndianOceanTerritory: 'Brytyjskie Terytorium Oceanu Indyjskiego',
    BruneiDarussalam: 'Brunei',
    Bulgaria: 'Bułgaria',
    BurkinaFaso: 'Burkina Faso',
    Burundi: 'Burundi',
    Cambodia: 'Kambodża',
    Cameroon: 'Kamerun',
    Canada: 'Kanada',
    CapeVerde: 'Wyspy Zielonego Przylądka',
    CaymanIslands: 'Kajmany',
    CentralAfricanRepublic: 'Republika Środkowoafrykańska',
    Chad: 'Czad',
    Chile: 'Chile',
    China: 'Chiny',
    ChristmasIsland: 'Wyspa Bożego Narodzenia',
    CocosKeelingIslands: 'Wyspy Kokosowe Keelinga',
    Colombia: 'Kolumbia',
    Comoros: 'Komory',
    Congo: 'Kongo',
    DemocraticRepublicoftheCongo: 'Demokratyczna Republika Konga',
    CookIslands: 'Wyspy Cooka',
    CostaRica: 'Kostaryka',
    CôtedIvoire: 'Wybrzeże Kości Słoniowej',
    Croatia: 'Chorwacja',
    Cuba: 'Kuba',
    Curaçao: 'Curacao',
    Cyprus: 'Cypr',
    CzechRepublic: 'Czechy',
    Denmark: 'Dania',
    Djibouti: 'Dżibuti',
    Dominica: 'Dominikana',
    DominicanRepublic: 'Republika Dominikany',
    Ecuador: 'Ekwador',
    Egypt: 'Egipt',
    ElSalvador: 'Ekwador',
    EquatorialGuinea: 'Gwinea Równikowa',
    Eritrea: 'Erytrea',
    Estonia: 'Estonia',
    Ethiopia: 'Etiopia',
    FalklandIslands: 'Falklandy',
    FaroeIslands: 'Wyspy Owcze',
    Fiji: 'Fidżi',
    Finland: 'Finlandia',
    France: 'Francja',
    FrenchGuiana: 'Gujana Francuska',
    FrenchPolynesia: 'Polinezja Francuska',
    FrenchSouthernTerritories: 'Francuskie Terytoria Południowe',
    Gabon: 'Gabon',
    Gambia: 'Gambia',
    Georgia: 'Gruzja',
    Germany: 'Niemcy',
    Ghana: 'Ghana',
    Gibraltar: 'Gibraltar',
    Greece: 'Grecja',
    Greenland: 'Grenlandia',
    Grenada: 'Grenada',
    Guadeloupe: 'Gwadelupa',
    Guam: 'Guam',
    Guatemala: 'Gwatemala',
    Guernsey: 'Guernsey',
    Guinea: 'Gwinea',
    GuineaBissau: 'Gwinea Bissau',
    Guyana: 'Gujana',
    Haiti: 'Haiti',
    HeardIslandandMcDonaldIslands: 'Wyspy Heard i Wyspy McDonalda',
    HolySeeVaticanCityState: 'Watykan',
    Honduras: 'Honduras',
    HongKong: 'Hong Kong',
    Hungary: 'Węgry',
    Iceland: 'Islandia',
    India: 'Indie',
    Indonesia: 'Indonezja',
    IslamicRepublicIran: 'Islamska Republika Iranu',
    Iraq: 'Irak',
    Ireland: 'Irlandia',
    IsleofMan: 'Wyspa Man',
    Israel: 'Izrael',
    Italy: 'Włochy',
    Jamaica: 'Jamajka',
    Japan: 'Japonia',
    Jersey: 'Jersey',
    Jordan: 'Jordania',
    Kazakhstan: 'Kazachstan',
    Kenya: 'Kenia',
    Kiribati: 'Kiribati',
    NorthKorea: 'North Korea',
    SouthKorea: 'South Korea',
    Kuwait: 'Republika Kuwejtu',
    Kyrgyzstan: 'Kirgistan',
    LaoDemocraticRepublic: 'Republika Demokratyczna Laosu',
    Latvia: 'Łotwa',
    Lebanon: 'Liban',
    Lesotho: 'Lesotho',
    Liberia: 'Liberia',
    Libya: 'Libia',
    Liechtenstein: 'Liechtenstein',
    Lithuania: 'Litwa',
    Luxembourg: 'Luxembourg',
    Macao: 'Makau',
    Macedonia: 'Macedonia',
    Madagascar: 'Madagascar',
    Malawi: 'Malawi',
    Malaysia: 'Malezja',
    Maldives: 'Malediwy',
    Mali: 'Mali',
    Malta: 'Malta',
    MarshallIslands: 'Wyspy Marshalla',
    Martinique: 'Martynika',
    Mauritania: 'Mauretania',
    Mauritius: 'Mauritius',
    Mayotte: 'Majotta',
    Mexico: 'Meksyk',
    Micronesia: 'Mikronezja',
    Moldova: 'Mołdawia',
    Monaco: 'Księstwo Monako',
    Mongolia: 'Mongolia',
    Montenegro: 'Czarnogóra',
    Montserrat: 'Montserrat',
    Morocco: 'Maroko',
    Mozambique: 'Mozambik',
    Myanmar: 'Myanmar',
    Namibia: 'Namibia',
    Nauru: 'Nauru',
    Nepal: 'Nepal',
    Netherlands: 'Holandia',
    NewCaledonia: 'Nowa Kaledonia',
    NewZealand: 'Nowa Zelandia',
    Nicaragua: 'Nikaragua',
    Niger: 'Niger',
    Nigeria: 'Nigeria',
    Niue: 'Niue',
    NorfolkIsland: 'Wyspa Norfolk',
    NorthernMarianaIslands: 'Mariany Północne',
    Norway: 'Norwegia',
    Oman: 'Oman',
    Pakistan: 'Pakistan',
    Palau: 'Palau',
    PalestinianTerritoryOccupied: 'Teretorium Paleństynskie, Okupowane',
    Panama: 'Panama',
    PapuaNewGuinea: 'Papua-Nowa Gwinea',
    Paraguay: 'Paragwaj',
    Peru: 'Peru',
    Philippines: 'Filipiny',
    Pitcairn: 'Pitcairn',
    Poland: 'Polska',
    Portugal: 'Portugalia',
    PuertoRico: 'Portoryko',
    Qatar: 'Katar',
    Réunion: 'Reunion',
    Romania: 'Rumunia',
    RussianFederation: 'Rosja',
    Rwanda: 'Rwanda',
    SaintBarthélemy: 'Saint-Barthélemy',
    SaintHelena: 'Wyspa Świętej Heleny',
    SaintKittsAndNevis: 'Saint Kitts i Nevis',
    SaintLucia: 'Santa Lucia',
    SaintMartinFrenchPart: 'Saint Martin (część francuska)',
    SaintPierreandMiquelon: 'Wspólnota Terytorialna Saint Pierre i Miquelon',
    SaintVincentandtheGrenadines: 'Saint Vincent i Grenadyny',
    Samoa: 'Samoa',
    SanMarino: 'San Marino',
    SaoTomeandPrincipe: 'Wyspy Świętego Tomasza i Książęca',
    SaudiArabia: 'Arabia Saudyjska',
    Senegal: 'Senegal',
    Serbia: 'Serbia',
    Seychelles: 'Seszele',
    SierraLeone: 'Sierra Leone',
    Singapore: 'Singapur',
    SintMaarten: 'Sint Maarten',
    Slovakia: 'Słowacja',
    Slovenia: 'Słowenia',
    SolomonIslands: 'Wyspy Salomona',
    Somalia: 'Somalia',
    SouthAfrica: 'Afryka Południowa',
    SouthGeorgiaandtheSouthSandwichIslands: 'Georgia Południowa i Sandwich Południowy ',
    SouthSudan: 'Południowy Sudan',
    Spain: 'Hiszpania',
    SriLanka: 'Sri Lanka',
    Sudan: 'Sudan',
    Suriname: 'Surinam',
    SvalbardandJanMayen: 'Svalbard i Jan Mayen',
    Swaziland: 'Suazi',
    Sweden: 'Szwecja',
    Switzerland: 'Szwajcaria',
    SyrianArabRepublic: 'Syria',
    Taiwan: 'Tajwan',
    Tajikistan: 'Tadżykistan',
    Tanzania: 'Tanzania',
    Thailand: 'Tajlandia',
    TimorLeste: 'Timor Wschodni',
    Togo: 'Togo',
    Tokelau: 'Tokelau',
    Tonga: 'Tonga',
    TrinidadandTobago: 'Trynidad i Tobago',
    Tunisia: 'Tunezja',
    Turkey: 'Turcja',
    Turkmenistan: 'Turkmenia',
    TurksandCaicosIslands: 'Wyspy Turks i Caicos',
    Tuvalu: 'Tuvalu',
    Uganda: 'Uganda',
    Ukraine: 'Ukraina',
    UnitedArabEmirates: 'Zjednoczone Emiraty Arabskie',
    UnitedKingdom: 'Wielka Brytania',
    UnitedStates: 'Stany Zjednoczone',
    UnitedStatesMinorOutlyingIslands: 'Stany Zjednoczone Dalekie Wyspy Mniejsze',
    Uruguay: 'Urugwaj',
    Uzbekistan: 'Uzbekistan',
    Vanuatu: 'Vanuatu',
    Venezuela: 'Wenezuela',
    VietNam: 'Wietnam',
    VirginIslandsBritish: 'Brytyjskie Wyspy Dziewicze',
    VirginIslandsUS: 'Wyspy Dziewicze Stanów Zjednoczonych',
    WallisandFutuna: 'Wallis i Futuna',
    WesternSahara: 'Sahara Zachodnia',
    Yemen: 'Jemen',
    Zambia: 'Zambia',
    Zimbabwe: 'Zimbabwe',
  },
  months: {
    January: 'Styczeń',
    February: 'Luty',
    March: 'Marzec',
    April: 'Kwiecień',
    May: 'Maj',
    June: 'Czerwiec',
    July: 'Lipiec',
    August: 'Sierpień',
    September: 'Wrzesień',
    October: 'Październik',
    November: 'Listopad',
    December: 'Grudzień',
  },
};
